export default {
  translation: {
    commonUsedWords: {
      login: '로그인',
      email: '이메일 주소',
      password: '비밀번호',
      emailIsRequired: '이메일은 필수 항목입니다',
      mustBeAValidEmail: '유효한 이메일 주소여야 합니다!',
      deviceSerialNumber: '디바이스 일련번호',
      next: '다음',
      back: '뒤로',
      success: '성공',
      submit: '제출',
      firstName: '이름',
      firstNameIsRequired: '이름은 필수 항목입니다',
      lastName: '성',
      lastNameIsRequired: '성은 필수 항목입니다',
      save: '저장',
      delete: '삭제',
      undoChanges: '변경 취소',
      cancel: '취소',
      loading: '로딩 중...',
      yes: '예',
      no: '아니오',
      clear: '지우기',
      confirm: '확인',
      noOption: '옵션 없음',
      noCompressorTemplatesFound: '컴프레서 템플릿이 없습니다',
      openText: '열기',
      edit: '편집',
      logout: '로그아웃',
      update: '업데이트',
      locked: '잠김',
      unlocked: '잠금 해제',
      latitude: '위도 (LAT)',
      longitude: '경도 (LONG)',
      ok: 'OK',
      okay: '오케이',
      done: '완료',
      comingSoon: '곧 제공될 예정...',
      reset: '초기화',
      attention: '주의',
      note: '참고',
      continue: '계속',
      finish: '마침',
      required: '이 필드는 필수입니다',
      close: '닫기',
      copiedToClipboard: '클립보드에 복사됨',
      apply: '적용',
    },
    api: {
      auth: {
        fieldsAreMissing: '필수 항목이 누락되었습니다',
        userNotFound: '사용자를 찾을 수 없습니다',
        missingRefreshToken: '리프레시 토큰이 없습니다',
        cannotRefreshToken: '토큰을 갱신할 수 없습니다',
      },
      helpers: {
        error: '오류',
        invalidHTTPMethod: '유효하지 않은 HTTP 메서드입니다',
      },
    },
    components: {
      autocompleteField: {
        presets: '프리셋',
        results: '결과',
      },
      dateRangePicker: {
        changeDates: '날짜 변경',
        selectDateRange: '날짜 범위 선택',
        startDate: '시작 날짜',
        endDate: '종료 날짜',
        datePresets: {
          label: '날짜 프리셋',
          today: '오늘',
          yesterday: '어제',
          last7Days: '지난 7일',
          last30Days: '지난 30일',
          thisWeek: '이번 주',
          lastWeek: '지난 주',
          thisMonth: '이번 달',
          lastMonth: '지난 달',
          thisYear: '올해',
          lastYear: '작년',
          allTime: '전체 기간',
        },
        calendar: {
          weekDays: {
            mon: '월',
            tue: '화',
            wed: '수',
            thu: '목',
            fri: '금',
            sat: '토',
            sun: '일',
          },
          months: {
            january: '1월',
            february: '2월',
            march: '3월',
            april: '4월',
            may: '5월',
            june: '6월',
            july: '7월',
            august: '8월',
            september: '9월',
            october: '10월',
            november: '11월',
            december: '12월',
          },
        },
      },
      confirmEmail: {
        confirmEmail: '이메일 주소 확인',
        confirmEmailIsRequired: '확인용 이메일은 필수 항목입니다',
        emailNotMatched: '입력한 이메일이 일치하지 않습니다',
      },
      confirmPassword: {
        confirmPassword: '비밀번호 확인',
        confirmPasswordIsRequired: '확인 비밀번호는 필수 항목입니다',
        newPasswordIsRequired: '새 비밀번호는 필수 항목입니다',
        showPassword: '비밀번호 표시',
        passwordLength: '비밀번호는 6자 이상이어야 합니다',
        passwordContainSpaces: '비밀번호에는 공백을 포함할 수 없습니다',
        passwordNotMatch: '비밀번호가 일치하지 않습니다',
        newPassword: '새 비밀번호',
      },
      confirmModal: {
        areYouSure: '정말로 진행하시겠습니까?',
      },
      appliedFilters: {
        between: '{{firstValue}}와 {{secondValue}} 사이',
        bottom: '하위 {{primaryValue}}%',
        top: '상위 {{primaryValue}}%',
        activeFilters: '활성 필터',
        active: '활성',
        closed: '닫힘',
      },
      editTable: {
        editTable: '테이블 편집',
        selectDeselect: '테이블 값 선택 / 선택 해제',
        resetToDefault: '기본값으로 재설정',
      },
      errorBoundary: {
        oops: '이런! 예기치 않은 문제가 발생했습니다.',
        tryAgain: '다시 시도해 주세요! 문제가 지속되면 관리자에게 문의하세요.',
        refresh: '새로 고침',
      },
      noResultFound: {
        noResultFoundTryAgain: '죄송합니다. 결과를 찾지 못했습니다. 다시 시도해 주세요.',
      },
      permissionGuard: {
        invalidPermission: '잘못된 권한 구조입니다. 배열에 3개의 요소가 필요합니다.',
      },
      preview: {
        findInView: '화면에서 찾기',
        showDetails: '세부 정보 표시',
        closeEsc: '닫기 (Esc)',
        prevLeftArrow: '이전 (왼쪽 화살표)',
        nextRightArrow: '다음 (오른쪽 화살표)',
        proceedWithoutSaving: '저장하지 않고 이동',
        continueEditing: '편집 계속',
        unsavedChanges: {
          partTwo: '현재 ',
          partThree: '저장되지 않은 변경 사항',
          partFour: '이 있습니다. 저장하지 않고 이동하면 모든 변경 사항이 삭제됩니다. 계속하시겠습니까?',
        },
      },
      printRecord: {
        title: '기록',
        date: '날짜:',
        location: '위치',
        leakDetails: '세부 정보',
        leakParameters: '파라미터',
        energyLoss: '에너지 손실',
        leakSourceEquipment: '소스 장비',
        notes: '노트',
        leakEventStatus: '상태',
        requiredAction: '필요한 조치',
        leakSourceImage: '소스 이미지',
        sourceImages: '소스 이미지',
        additionalImages: '추가 이미지',
        additionalImage: '추가 이미지',
        smartLeakTag: '스마트 태그',
        workRef: '작업 참조',
        lossPerYear: '손실 ({{currency}}/년)',
        costOfEnergy: '에너지 비용 ({{currency}}/kWh)',
        eventRecordTitle: '이벤트 기록',
        recordedOn: '{{date}}에 기록됨',
        eventParameters: '이벤트 매개변수',
        eventMetrics: '이벤트 지표',
        sourceEquipment: '소스 장비',
        eventStatus: '이벤트 상태',
        sourceImageCaptures: '소스 이미지 캡처',
        fftNotAvailable: '이 기록에 대한 FFT 데이터가 없습니다',
        imageNotAvailable: '이미지를 사용할 수 없습니다',
        generatedOn: '{{date}}에 생성됨',
        pageOfTotal: '페이지 {{page}} / {{total}}',
        energyPerYear: '에너지 (kWh/년)',
      },
      exportSectionsDialog: {
        title: '내보낼 섹션 선택',
        exportingSingular: '1개의 기록을 내보내는 중.',
        exportingPlural: '{{count}}개의 기록을 내보내는 중.',
        selectSectionsHint: 'PDF에 포함할 섹션을 선택하세요.',
        visualizationsHint: '시각화에는 추가 렌더링이 필요하며 대용량 내보내기의 경우 몇 초가 더 걸릴 수 있습니다.',
        default: '기본값',
        selectAll: '모두 선택',
        groups: {
          summary: '요약',
          clientLocation: '고객 및 위치',
          recordDetails: '기록 세부정보',
          source: '소스',
          status: '상태',
          visualizations: '시각화',
        },
        sections: {
          summary: '요약 페이지',
          clientInfo: '고객 정보',
          leakParameters: '이벤트 매개변수',
          energyLoss: '에너지 손실 / 전기 매개변수',
          leakMetrics: '이벤트 지표',
          sourceEquipment: '소스 장비 + 이미지',
          leakStatus: '이벤트 상태',
          fft: 'FFT 주파수 스펙트럼',
        },
      },
      assignedAction: {
        actionHeader: {
          deleteAssignmentSuccess: '할당이 삭제되었습니다',
          deleteAssignmentError: '할당을 삭제할 수 없습니다. 나중에 다시 시도해 주세요',
          currentlyAssigned: '현재 할당된 작업',
          repairedBy: '수리자',
          text: '이 할당을 삭제하려고 합니다. 이 작업은 되돌릴 수 없습니다',
        },
        actionSaveDate: '마지막 저장',
      },
      visibleColumnsPopper: {
        tableValues: '테이블 값 선택 / 선택 해제',
      },
      tableHead: {
        deselectCurrentPage: '현재 페이지 선택 해제',
        selectCurrentPage: '현재 페이지 선택',
      },
      coverPage: {
        costDisclaimer: '참고: 재정적 손실 및 비용 절감은 압축 공기 누출 기록에만 해당됩니다.',
        title: '기록 보고서',
        reportDate: '보고 날짜: {{date}}',
        poweredBy: '{{companyName}}<reg>®</reg> 제공',
        date: '날짜 범위: {{from}} - {{to}}',
        includedRecords: '포함된 기록: {{count}}',
        totalLoss: '총 손실',
        lossByCurrency: '{{currency}}: {{loss}}',
        totalKwhLoss: '총 kWh 손실: {{kwh}} kWh/년',
      },
      tagsCoverPage: {
        title: '스마트 태그 보고서',
        reportDate: '보고 날짜: {{date}}',
        poweredBy: '{{companyName}}<reg>®</reg> 제공',
        date: '날짜 범위: {{from}} - {{to}}',
        includedTags: '포함된 스마트 태그: {{count}}',
        includedRecords: '포함된 기록: {{count}}',
        totalKwhLoss: '총 kWh 손실: {{kwh}} kWh/년',
      },
    },
    constants: {
      qualifiers: {
        EQUAL_TO: '같음',
        LESS_THAN: '미만',
        GREATER_THAN: '초과',
        LESS_THAN_OR_EQUAL_TO: '이하',
        GREATER_THAN_OR_EQUAL_TO: '이상',
        BETWEEN_A_AND_Y: '사이',
        TOP_PERCENT: '상위 "x"%',
        BOTTOM_PERCENT: '하위 "x"%',
      },
      recordFields: {
        CREATED_AT: '생성일',
        RECORD_ID: '기록 ID 번호',
        DOCUMENT_ID: '기록 ID 번호',
        DOLLARS_PER_YEAR: '손실액',
        GAS_COMPONENT: '가스/구성 요소',
        LEAK_TYPE: '유형 프로필',
        DATE_TIME: '생성 일시',
        DB_PEAK: '피크 dB',
        COMPANY: '회사',
        NOTES: '노트',
        USER: '사용자',
        EQUIPMENT_TAG: '장비/구성 요소 태그',
        FLOW: '유량 (m³/h)',
        EQUIPMENT: '유닛/건물/기계',
        ROUTE: '경로',
        ROUTE_LOCATION: '경로 위치',
        ROUTE_EQUIPMENT_NAME: '경로 장비',
        PROJECT_SURVEY: '감사/조사 기록 참조',
        OUTAGE_STATUS: '정전/중단 필요 여부?',
        FACILITY: '시설/사이트',
        ACTION_STATUS: '조치 상태',
        SERVICE_TYPE: '서비스/유형',
        DB_ACTIVE: '활성 dB',
        REFERENCE_ID: '프로젝트 번호/조사 ID',
        AMBIENT_TEMPERATURE: '주위 온도 (°C)',
        LEAK_PRESSURE: '압력 (kPag)',
        LEAK_TEMPERATURE: '가스 온도 (°C)',
        LEAK_CATEGORY: '카테고리',
        DISTANCE: '거리 (m)',
        GAS_COST: '가스 비용 ($/m³)',
        COMPRESSOR_FLOW: 'BHP당 m³/h',
        DEVICE_ID: '디바이스 ID',
        COMPRESSOR_BHP: '컴프레서 BHP',
        COMPRESSOR_TYPE: '컴프레서 유형',
        MOTOR_EFFICIENCY: '모터 효율 (%)',
        ENERGY_COST: '에너지 비용 ($/kWh)',
        HOURS: '연간 가동 시간',
        LOCATION: '위치',
        LAST_MODIFIED: '마지막 저장 일시',
        POWER_LOAD: '% 정격 부하',
        CLIENT: '고객',
        SERVICE: '서비스',
        CAPACITY: '용량 (%)',
        EQUIPMENT_TYPE: '장비/구성 요소 유형',
        SMART_TAG: '스마트 태그 #',
        WORK_REF: '작업 참조 #',
        REPAIRED_BY: '수리자',
        ALTITUDE: '해발고도 (m)',
        REQUIRED_ACTION: '필요한 조치',
        FREQUENCY_LOW_BOUND: '주파수 (하한)',
        FREQUENCY_HIGH_BOUND: '주파수 (상한)',
        SENSITIVITY: '민감도',
        KWH_PER_YEAR: 'kWh/년',
        ASSIGNED_BY: '할당자',
        ASSIGNED_TO: '할당 대상',
        ASSIGNED_DATE: '할당 날짜',
        LOSS_PER_YEAR: '연간 손실',
        ASSIGNED: '할당됨',
        CREATOR_USER_ID: '사용자 ID',
        CURRENCY: '통화',
        COMPLETED_ON: '완료일',
        IMAGES: '소스 이미지',
        ACTION_STATUS_MODIFIED: '조치 상태 변경',
        TYPE: '유형',
      },
      electricalRecordFields: {
        REGION: '지역',
        LOCATION_TYPE: '위치 유형',
        VOLTAGE: '전압',
        PHASE: '상',
        FREQUENCY: '주파수',
        ELECTRICAL_EQUIPMENT_TAG: '장비/구성 요소',
        ELECTRICAL_EQUIPMENT_TYPE: '장비/구성 요소 유형',
        FAULT_TYPE: '고장 유형',
        ELECTRICAL_NOTES: '노트',
      },
      IMPERIAL_LABELS: {
        FLOW: '유량 (cfm)',
        AMBIENT_TEMPERATURE: '주위 온도 (°F)',
        LEAK_PRESSURE: '압력 (psi)',
        LEAK_TEMPERATURE: '가스 온도 (°F)',
        DISTANCE: '거리 (ft)',
        GAS_COST: '가스 비용 ($/ft³)',
        COMPRESSOR_FLOW: 'BHP당 cfm',
        ALTITUDE: '해발고도 (ft)',
      },
      METRIC_EU_LABELS: {
        FLOW: '유량 (m³/min)',
        LEAK_PRESSURE: '압력 (bar)',
        COMPRESSOR_FLOW: 'BHP당 m³/min',
      },
      userFields: {
        EMAIL: '이메일',
        ROLE: '역할',
        DEVICE_ID: '디바이스 ID',
        SUBSCRIPTION_RENEWAL_DATE: '구독 갱신일',
        DATE_TIME: '생성일',
        ACTIVE: '상태',
        SOFTWARE_VERSION: '소프트웨어 버전',
        FIRMWARE_VERSION: '펌웨어 버전',
        FIRST_NAME: '이름',
        LAST_NAME: '성',
        COMPANY_SLUG: '회사',
        COMPANY_NAME: '회사',
      },
      auditFields: {
        documentId: '기록 ID 번호',
        companyName: '회사 이름',
        auditorName: '감사자 이름',
        auditorEmail: '감사자 이메일',
        createdAt: '생성일',
        updatedAt: '업데이트일',
        comment: '코멘트',
        isLocked: '감사 잠금',
      },
      deviceFields: {
        DEVICE_ID: '디바이스 ID',
        ACTIVE: '상태',
        REGISTERED_ON: '활성화일',
        EVENT_COUNT: '기록 수',
        UNIQUE_COMPANIES: '회사 수',
        LAST_USED_AT: '마지막 사용일',
        LAST_USED_BY_NAME: '마지막 사용자 이름',
        LAST_USED_BY_EMAIL: '마지막 사용자 이메일',
        LOCATION: '마지막 사용 위치',
        FIRMWARE_VERSION: '펌웨어 버전',
      },
      enpisFields: {
        labels: {
          NO_OF_LEAKS_FOUND: '발견된 누출 수',
          NO_OF_LEAKS_REPAIRED: '수리된 누출 수',
          PERCENT_LEAKS_REPAIRED: '누출 수리 비율',
          VOL_FLOW_FOUND: '발견된 체적 유량 (m³/h)',
          VOL_FLOW_REPAIRED: '수리된 체적 유량 (m³/h)',
          PERCENT_VOL_FLOW_REPAIRED: '체적 유량 수리 비율',
          VALUE_FOUND: '발견된 값',
          VALUE_REPAIRED: '수리된 값',
          ENERGY_SAVING_OPPORTUNITY_FOUND: '에너지 절감 기회 (발견) (kWh)',
          ENERGY_SAVING_OPPORTUNITY_PERCENT: '에너지 절감 기회 비율 (발견 vs 계산 또는 측정)',
          ENERGY_SAVING_REALIZED_FIXED: '실현된 에너지 절감 (고정) (kWh)',
          ENERGY_SAVING_REALIZED_PERCENT: '실현된 에너지 절감 비율 (고정 vs 계산 또는 측정)',
          SYSTEM_CONTROL_PRESSURE_REDUCED: '시스템 제어 압력 감소 (kPag)',
        },
        labelsImperial: {
          VOL_FLOW_FOUND: '발견된 체적 유량 (cfm)',
          VOL_FLOW_REPAIRED: '수리된 체적 유량 (cfm)',
          ENERGY_SAVING_OPPORTUNITY_FOUND: '에너지 절감 기회 (발견) (BTU)',
          ENERGY_SAVING_REALIZED_FIXED: '실현된 에너지 절감 (고정) (BTU)',
          SYSTEM_CONTROL_PRESSURE_REDUCED: '시스템 제어 압력 감소 (psi)',
        },
        labelsMetricEu: {
          VOL_FLOW_FOUND: '발견된 체적 유량 (m³/min)',
          VOL_FLOW_REPAIRED: '수리된 체적 유량 (m³/min)',
          SYSTEM_CONTROL_PRESSURE_REDUCED: '시스템 제어 압력 감소 (bar)',
        },
        columns: {
          PERFORMANCE_INDICATOR: '성과 지표',
          ENPI_VALUE: 'EnPI 값',
          ENB_VALUE: 'EnB 값',
          SUCCESS_THRESHOLD: '성공 임계값 (%)',
        },
      },
      companiesFields: {
        labels: {
          NAME: '이름',
          COUNTRY_ID: '국가',
          CURRENCY: '통화',
          LANGUAGE: '언어',
          INDUSTRY: '산업',
        },
      },
      assignedAction: {
        assignedTo: '할당 대상',
        assignedBy: '할당자',
        assignedDate: '할당 날짜',
        requestReassign: '재할당 요청',
        actionStatus: '조치 상태',
        partsNeeded: '필요 부품',
        productionOutage: '가동 중단 요청',
        timeToRepair: '수리 시간',
        repairCost: '수리 비용',
        closeOutRef: '종결 참조',
        'assignmentRecord.documentId': '기록 ID',
        assignmentId: '할당 ID',
        owner: '소유자',
        companyName: '회사',
        assignmentActive: '할당 상태',
        'assignmentRecord.leakStatus.building': '유닛/건물/기계',
        'assignmentRecord.leakStatus.facility': '시설',
        'assignmentRecord.leakStatus.routeName': '경로',
        'assignmentRecord.leakStatus.smartTag': '스마트 태그 #',
        'assignmentRecord.leakStatus.workRef': '작업 참조 #',
        'assignmentRecord.currency': '통화',
      },
      AAR_FIELD_LABEL: {
        NOTES: '실행 내용',
        CLOSE_OUT_REF: '조치 종결 참조 #',
        PARTS_NEEDED: '새 부품/구성 요소 필요',
        PRODUCTION_OUTAGE: '생산 중단됨',
        REPAIR_COST: '비용 ($)',
        REQUEST_REASSIGN: '재할당 요청',
        ACTION_STATUS: '조치 상태',
        TIME_TO_REPAIR: '수리 소요 시간 (분)',
      },
      leak: {
        chartsLabels: {
          FLOW_BY_LEAK: '누출 카테고리별 유량',
          LOSS_BY_LEAK: '누출 카테고리별 손실',
          TAGS_BY_LEAK: '누출 카테고리별 태그',
          AVG_FLOW_BY_LEAK: '누출 카테고리별 평균 유량',
          SAVING_OPT_BY_REPAIR: '수리 시간별 기회 및 절감',
          FLOW_REPAIR_TIME: '수리 시간별 유량',
          LOSS_REPAIR_TIME: '수리 시간별 손실',
          FLOW_REPAIR_PROG: '수리 진행 상황별 유량',
          TOTAL_REPAIR_PROG: '수리 진행 상황별 손실',
          FLOW_BY_EQUIP_COMP: '장비/구성 요소별 유량',
          LOSS_BY_EQUIP_COMP: '장비/구성 요소별 손실',
          TAGS_BY_EQUIP_COMP: '장비/구성 요소별 태그',
        },
        leakCategoryLabels: {
          LOW: '낮음',
          MEDIUM: '중간',
          HIGH: '높음',
        },
        actionStatus: {
          OPEN: '열림',
          COMPLETE: '완료',
        },
        equipmentTypes: {
          CONNECTOR: '커넥터',
          CONTROL_VALVE: '제어 밸브',
          HOSE: '호스',
          TUBE_FITTING: '튜브 피팅',
          METER: '미터',
          OPEN_ENDED_LINE: '개방식 라인',
          PRESSURE_RELIEF_VALVE: '압력 안전밸브',
          PUMP_SEAL: '펌프 씰',
          REGULATOR: '조정기',
          VALVE: '밸브',
          LEVEL_CONTROLLER: '레벨 컨트롤러',
          POSITIONER: '포지셔너',
          PRESSURE_CONTROLLER: '압력 컨트롤러',
          TRANSDUCER: '트랜스듀서',
          GENERIC_PNEUMATIC_INSTRUMENT: '범용 공압 기기',
          GENERIC_RECIPROCATING_COMPRESSOR: '범용 왕복동 압축기',
          GENERIC_CENTRIFUGAL_COMPRESSOR: '범용 원심 압축기',
        },
        mainGasValues: {
          AIR: '공기',
          METHANE: '메탄 (CH4)',
          CARBON_DIOXIDE: '이산화탄소 (CO2)',
          HYDROGEN: '수소 (H2)',
          HELIUM: '헬륨 (He)',
          NITROGEN: '질소 (N2)',
          REFRIGERANT: '냉매 (HFCs)',
          ARGON: '아르곤 (Ar)',
          OXYGEN: '산소 (O)',
          WATER: '물 (증기)',
        },
        leakTypeValues: {
          DEFAULT: '선택 사항 없음',
          HOLE: '구멍',
          CRACK: '균열',
          FITTING: '피팅',
          FLANGE: '플랜지',
          'GLAND/SEAL': '글랜드/씰',
          THREAD: '나사선',
          'TUBE/HOSE': '튜브/호스',
        },
        serviceValues: {
          COMPRESSED_AIR: '압축 공기',
          VACUUM: '진공',
          STEAM: '스팀',
          PROCESS_GAS: '공정 가스',
          LIQUID: '액체',
        },
        compressorTypesValues: {
          ROTARY_SCREW: '로터리 스크류',
          RECIPROCATING: '왕복',
          SCROLL: '스크롤',
          CENTRIFUGAL: '원심',
        },
        regionValues: {
          NORTH_AMERICA: '북아메리카',
          OUTSIDE_NORTH_AMERICA: '북아메리카 외 지역',
        },
        locationTypeValues: {
          RESIDENTIAL: '주거',
          COMMERCIAL: '상업',
          INDUSTRIAL: '산업',
          MEDIUM_VOLTAGE: '중전압',
          HIGH_VOLTAGE: '고전압',
        },
        phaseValues: {
          SINGLE_PHASE: '단상',
          THREE_PHASE: '3상',
        },
        faultValues: {
          SELECT_FAULT_TYPE: '고장 유형 선택',
          KNICKS_OR_VOIDS_IN_INSULATION: '절연 손상 또는 공극',
          CORONA: '코로나',
          TREEING: '트리잉',
          TRACKING: '트래킹',
          ARCING: '아킹',
          'DIRTY_POWER/POWER_DISTORTION': '불량 전원/전원 왜곡',
          MECHANICAL_LOOSENESS: '기계적 이완',
          DELAMINATION_OF_WINDINGS: '권선 박리',
          LOOSE_PANEL: '느슨한 패널',
          VIBRATING_NAMEPLATE: '진동하는 명판',
          ANTAGONISTIC_ULTRASOUND: '역상 초음파',
          OTHER: '기타',
        },
        electricEquipmentTypeValues: {
          MCC: 'MCC (모터 제어 장비)',
          'TRANSFORMER,_DRY': '변압기 (건식)',
          'TRANSFORMER,_OIL': '변압기 (유입식)',
          SWITCH_GEAR: '스위치기어',
          PANEL: '패널',
          BUSDUCT: '버스덕트',
          CABLE: '케이블',
          CONNECTOR: '커넥터',
          BREAKER: '차단기',
          BUSHING: '부싱',
          TRANSMISSION_LINE: '송전선',
          'TRANSFORMER,_POLE': '변압기 (전주형)',
          BATTERY: '배터리',
          BATTERY_BANK: '배터리 뱅크',
          TERMINALS: '터미널',
          'TRANSFORMER,_STEP_UP': '변압기 (승압)',
          'TRANSFORMER,_STEP_DOWN': '변압기 (강압)',
          DISTRIBUTION_PANEL: '배전반',
          BREAKER_PANEL: '차단기 패널',
          RELAYS: '릴레이',
          CAPACITORS: '커패시터',
          REACTORS: '리액터',
          UPS: 'UPS',
          GROUNDING: '접지',
          POWER_METERS: '전력계',
          CURRENT_TRANSFORMERS: '전류 변압기',
          POTENTIAL_TRANSFORMERS: '전압 변압기',
          SURGE_PROTECTION: '서지 보호장치',
          CABLE_TRAYS: '케이블 트레이',
          EMERGENCY_LIGHTING: '비상 조명',
          CONTACTORS: '콘택터',
          INVERTERS: '인버터',
          SOLAR_PANELS: '태양광 패널',
          BATTERY_STORAGE_SYSTEMS: '배터리 저장 시스템',
        },
        recordTypes: {
          leak: '누출',
          electrical: '전기',
        },
        labels: {
          LOW: '낮음',
          MEDIUM: '중간',
          HIGH: '높음',
          EQUIPMENT: '장비',
          SAVINGS: '절감',
          OPPORTUNITY: '기회',
          LOSS: '손실',
          REPAIRED: '수리됨',
          UNREPAIRED: '미수리',
          LESS_15_DAYS: '15일 미만',
          DAYS_16_TO_30: '16~30일',
          DAYS_31_TO_60: '31~60일',
          DAYS_61_TO_90: '60일 초과',
          LESS_THAN_15_DAYS: '15일 이내 수리',
          '16_TO_30_DAYS': '16~30일 이내 수리',
          '31_TO_60_DAYS': '31~60일 이내 수리',
          MORE_THAN_60_DAYS: '61~90일 이내 수리',
          AIR: '공기',
          METHANE: '메탄 (CH4)',
          CARBON_DIOXIDE: '이산화탄소 (CO2)',
          HYDROGEN: '수소 (H2)',
          HELIUM: '헬륨 (He)',
          NITROGEN: '질소 (N2)',
          REFRIGERANT: '냉매 (HFCs)',
          ARGON: '아르곤 (Ar)',
          OXYGEN: '산소 (O)',
          WATER: '물 (증기)',
          DEFAULT: '선택 사항 없음',
          HOLE: '구멍',
          CRACK: '균열',
          FITTING: '피팅',
          FLANGE: '플랜지',
          'GLAND/SEAL': '글랜드/씰',
          THREAD: '나사선',
          'TUBE/HOSE': '튜브/호스',
          COMPRESSED_AIR: '압축 공기',
          VACUUM: '진공',
          STEAM: '스팀',
          PROCESS_GAS: '공정 가스',
          LIQUID: '액체',
          ROTARY_SCREW: '로터리 스크류',
          RECIPROCATING: '왕복',
          SCROLL: '스크롤',
          CENTRIFUGAL: '원심',
          CONNECTOR: '커넥터',
          CONTROL_VALVE: '제어 밸브',
          HOSE: '호스',
          TUBE_FITTING: '튜브 피팅',
          METER: '미터',
          OPEN_ENDED_LINE: '개방 라인',
          PRESSURE_RELIEF_VALVE: '압력 안전밸브',
          PUMP_SEAL: '펌프 씰',
          REGULATOR: '조정기',
          VALVE: '밸브',
          LEVEL_CONTROLLER: '레벨 컨트롤러',
          POSITIONER: '포지셔너',
          PRESSURE_CONTROLLER: '압력 컨트롤러',
          TRANSDUCER: '트랜스듀서',
          GENERIC_PNEUMATIC_INSTRUMENT: '범용 공압 기기',
          GENERIC_RECIPROCATING_COMPRESSOR: '범용 왕복동 압축기',
          GENERIC_CENTRIFUGAL_COMPRESSOR: '범용 원심 압축기',
        },
        leakRecordPDF: '기록 - {{date}}',
        leakTag: '스마트 태그 - {{date}}',
      },
      compressorFields: {
        labels: {
          COMPRESSOR_TAG: '컴프레서 태그',
          COMPRESSOR_MAKE: '컴프레서 제조사',
          COMPRESSOR_MODEL: '컴프레서 모델',
          COMPRESSOR_TYPE: '컴프레서 유형',
          NAMEPLATE_HP: '명판 HP',
          NAMEPLATE_CAPACITY: '명판 용량 (m³/h)',
          MOTOR_EFFICIENCY: '모터 효율 (%)',
          MOTOR_VOLTAGE: '모터 전압',
          FULL_LOAD_CURRENT: '정격 부하 전류 (암페어)',
          FULL_LOAD_INPUT_POWER: '정격 부하 입력 전력 (kW)',
          RATED_PRESSURE: '정격 압력 (kPag)',
          PRESSURE_SETPOINT: '압력 설정값 (kPag)',
          CONTROL: '제어 방식',
          TOTAL_AIR_STORAGE_SIZE: '총 공기 저장 용량 (l)',
          IS_ACTIVE: '컴프레서 활성/비활성',
          OPERATION_TYPE: '트림 / 기준 부하',
          PERCENT_LOAD: '부하 비율 (%)',
          COMPRESSOR_SETPOINT_SEU: '컴프레서 설정값 (kPag)',
          COMPRESSOR_FLOW_SEU: '컴프레서 유량 (m³/h)',
          SYSTEM_PRESSURE_SETPOINT: '시스템 압력 설정값 (kPag)',
          SYSTEM_MEASURED_FLOW: '시스템 측정 유량 (m³/h)',
          DATE_TIME_RUNNING_STATE: '가동 상태 일시',
          NOTES: '노트',
          NAMEPLATE: '컴프레서 명판',
          DATASHEET: '컴프레서 데이터 시트',
          BHP: 'BHP',
          OPERATING_HOURS: '가동 시간',
          LOADED_PERCENT_TIME_RUNNING: '가동 시간 비중 (%)',
          LOADED_PERCENT_FULL_LOAD_BHP: '정격 부하 BHP 비율 (%)',
          UNLOADED_PERCENT_TIME_RUNNING: '무부하 가동 시간 비중 (%)',
          UNLOADED_PERCENT_FULL_LOAD_BHP: '무부하 정격 부하 BHP 비율 (%)',
          ENERGY_COST: '평균 전력 요금 ($)',
          ANNUAL_ENERGY_COST: '연간 에너지 비용 ($)',
          ANNUAL_ENERGY_KWH: '연간 에너지 사용량 (kWh)',
          COST_FULLY_LOADED: '완전 부하시 비용 ($)',
          COST_UNLOADED: '무부하시 비용 ($)',
          KWH_PER_YEAR_LOADED: '부하시 연간 kWh',
          KWH_PER_YEAR_UNLOADED: '무부하시 연간 kWh',
          ENERGY_COST_PER_UNIT: '$/m³',
        },
        labelsImperial: {
          NAMEPLATE_CAPACITY: '명판 용량 (cfm)',
          FULL_LOAD_INPUT_POWER: '정격 부하 입력 전력 (BTU/h)',
          RATED_PRESSURE: '정격 압력 (psi)',
          PRESSURE_SETPOINT: '압력 설정값 (psi)',
          TOTAL_AIR_STORAGE_SIZE: '총 공기 저장 용량 (gal)',
          COMPRESSOR_SETPOINT_SEU: '컴프레서 설정값 (psi)',
          COMPRESSOR_FLOW_SEU: '컴프레서 유량 (cfm)',
          SYSTEM_PRESSURE_SETPOINT: '시스템 압력 설정값 (psi)',
          SYSTEM_MEASURED_FLOW: '시스템 측정 유량 (cfm)',
          ENERGY_COST_PER_UNIT: '$/cf',
        },
        labelsMetricEu: {
          NAMEPLATE_CAPACITY: '명판 용량 (m³/min)',
          RATED_PRESSURE: '정격 압력 (bar)',
          PRESSURE_SETPOINT: '압력 설정값 (bar)',
          COMPRESSOR_SETPOINT_SEU: '컴프레서 설정값 (bar)',
          COMPRESSOR_FLOW_SEU: '컴프레서 유량 (m³/min)',
          SYSTEM_PRESSURE_SETPOINT: '시스템 압력 설정값 (bar)',
          SYSTEM_MEASURED_FLOW: '시스템 측정 유량 (m³/min)',
        },
      },
      energyFields: {
        labels: {
          UTILITY_PROVIDER: '전력 공급업체',
          ENERGY_COST: '$/kWh',
          ENERGY_UNIT: '단위',
          REBATE_COST: '$/kWh 리베이트',
          REBATE_UNIT: '리베이트 단위',
          ENERGY_SOURCES: '에너지 원',
          FE_HOURS_OPERATION: '운전 시간',
          FE_ENERGY_COST: '에너지 비용 ($/kWh)',
          FE_EFFICIENCY: '효율 (kW/m³/h)',
          KWH_PER_FLOW: 'kWh/m³/h',
          COST_PER_FLOW: '$/m³',
        },
        labelsImperial: {
          FE_EFFICIENCY: '효율 (kW/cfm)',
          KWH_PER_FLOW: 'kWh/cfm',
          COST_PER_FLOW: '$/cf',
        },
        labelsMetricEu: {
          FE_EFFICIENCY: '효율 (kW/m³/min)',
          KWH_PER_FLOW: 'kWh/m³/min',
        },
      },
    },
    hooks: {
      useError: {
        message: '요청 검증 오류입니다. 양식 항목을 확인해 주세요',
      },
    },
    layouts: {
      dashboardLayout: {
        topBar: {
          registerADevice: '디바이스 등록',
          help: '도움말',
          metric: '미터법',
          imperial: '야드파운드법',
          metricEu: 'Metric EU',
          downloadApk: 'APK 다운로드',
          downloadOta: '파일 다운로드',
        },
        otaDialog: {
          title: '파일 다운로드',
          downloadButton: '다운로드',
          serialNumberLabel: '디바이스 일련번호',
          serialNumberRequired: '일련번호는 필수 항목입니다',
          fileDownloaded: '{{fileName}} 파일이 성공적으로 다운로드되었습니다',
          errorFetchingFile: '파일을 가져오는 중 오류가 발생했습니다. 나중에 다시 시도해 주세요',
          selectSerialNumber: '디바이스 일련번호를 선택하세요',
        },
        banners: {
          leakRecordsList: {
            dialogOne: '현재 Essential 요금제를 사용 중입니다.',
            dialogTwo: '클릭 ',
            dialogThree: '여기',
            dialogFour: '새 관리자 라이선스를 구매하거나 문의하려면 ',
            dialogFive: 'support@prosaris.ca',
          },
          serviceUnavailable: '현재 기술적인 문제가 있어 서비스에 영향을 줄 수 있습니다. 불편을 드려 죄송합니다.',
          downForMaintenance: '현재 유지보수 중입니다. 나중에 다시 시도해 주세요.',
          tagsManagement: {
            question: 'PROSARIS 스마트 태그를 즐기고 계신가요?',
            purchaseLink: '여기에서 추가 스마트 태그를 구매하세요!',
          },
        },
        mobileNav: {
          index: {
            menu: '메뉴',
            editProfile: '프로필 편집',
            logout: '로그아웃',
          },
        },
        notifications: {
          title: 'Notifications',
          notificationsList: {
            clearAll: '모두 지우기',
            readAll: '모두 읽음 처리',
            noNotifications: '알림이 없습니다',
          },
        },
        index: {
          dashboard: '대시보드',
          records: '기록',
          actions: '조치',
          company: '회사',
          tags: '태그',
          support: 'Support',
        },
        loggedInAs: '현재 사용자',
      },
    },
    utils: {
      displayAssignedRecords: {
        cannontDeterminByField: '{{field}} 필드로 라벨을 확인할 수 없습니다',
        cannontDeterminByLabel: '{{label}} 라벨로 필드를 확인할 수 없습니다',
        active: '활성',
        closed: '종료',
      },
    },
    views: {
      commonUsedWords: {
        dashboard: '대시보드',
        records: '기록',
        actions: '조치',
        company: '회사',
        tags: '태그',
        redirecting: '이동 중...',
      },
      account: {
        index: {
          updatePassword: '비밀번호가 성공적으로 업데이트되었습니다.',
          accountDeletedSuccess: '계정 {{user}}이 성공적으로 삭제되었습니다',
          accountDeletedError: '현재 계정을 삭제할 수 없습니다. 나중에 다시 시도해 주세요.',
          authenticationError: '사용자 인증에 실패했습니다',
          currentPasswordIsRequired: '현재 비밀번호는 필수 항목입니다',
          firstNameIsRequired: '이름은 필수 항목입니다',
          lastNameIsRequired: '성은 필수 항목입니다',
          personalDetails: '기본 정보',
          changePassword: '비밀번호 재설정',
          currentPassword: '현재 비밀번호',
          profilePicture: '프로필 사진',
          dangerZone: '위험 구역',
          integrations: '통합',
          sosShipments: 'SOS 인벤토리',
          sosSyncMessage:
            '이 작업은 최신 SOS 인벤토리 데이터를 Prosaris의 SOS 주문 처리에 즉시 반영합니다. 일반적으로 4시간마다 예약 작업으로 자동 실행되지만, 이 버튼을 사용하면 수동으로 실행할 수 있습니다.',
          sosSyncSuccess: 'SOS 동기화가 성공적으로 트리거되었습니다',
          triggerSosSync: 'SOS 동기화 실행',
          hubspot: 'HubSpot',
          hubspotSyncMessage:
            '이 작업은 플랫폼의 최신 데이터를 즉시 HubSpot에 전송합니다. 기본적으로 매시간 예약 작업으로 자동 동기화되지만, 필요할 때 이 버튼으로 직접 실행할 수 있습니다.',
          hubspotSyncSuccess: 'HubSpot 동기화가 성공적으로 트리거되었습니다',
          triggerHubspotSync: 'HubSpot 동기화 실행',
          deleteAccountTitle: '계정 삭제',
          deleteAccountMessage: '계정이 더 이상 사용되지 않으며 모든 개인정보가 영구적으로 삭제됩니다.',
          alertTitle: '계정 삭제를 확인해 주세요',
          deleteDialog: {
            dialogTwo: '계정을 삭제하면 모든 개인정보가 데이터베이스에서 영구적으로 삭제됩니다.',
            dialogThree: '이 작업은 되돌릴 수 없습니다.',
            dialogFour: '계속하려면 비밀번호를 입력해 주세요.',
          },
        },
        toolBar: {
          cacheClearedSuccess: '캐시가 성공적으로 삭제되었습니다!',
          editProfile: '계정 정보',
          clearCache: '캐시 삭제',
          alertTitle: '앱 캐시 삭제를 확인해 주세요',
          deleteAll: '모두 삭제',
          accordionDialog: {
            dialogOne: '다음 페이지에 저장된 모든 설정이 삭제됩니다:',
            dialogTwo: '차트, 차트 필터, 기간',
            dialogThree: '필터, 정렬, 열, 미리보기',
            dialogFour: '필터, 열',
            dialogFive: '선택된 회사',
            dialogSix: '필터, 열',
          },
          deleteSelective: '선택 삭제',
          selectiveDialog: '삭제할 저장된 설정을 선택해 주세요:',
        },
        constants: {
          Dashboard: {
            TIMEFRAME: '기간',
            CHART_FILTERS: '차트 필터',
            CHARTS: '차트',
          },
          Records: {
            HIGHLIGHTED: '미리보기',
            COLUMNS: '열',
            FILTERS: '필터',
            SORT_COLUMN: '정렬',
          },
          Actions: {
            FILTERS: '필터',
            COLUMNS: '열',
          },
          Company: {
            SELECTED: '선택된 회사',
          },
          Tags: {
            FILTERS: '필터',
            COLUMNS: '열',
          },
        },
      },
      assignmentsList: {
        filters: {
          companyName: '회사',
          'leakStatus.building': '유닛/건물/기계',
          'leakStatus.facility': '시설',
          'leakStatus.smartTag': '스마트 태그 #',
          'leakStatus.workRef': '작업 참조 #',
        },
        tableBody: {
          noAssignmentsToDisplay: '표시할 할당이 없습니다',
        },
        filtersCommonWords: {
          recordsFilter: '기록 필터',
          column: '열',
          selectAColumn: '열을 선택하세요...',
          addSearchTerm: '검색어를 추가하세요...',
          filtersArentAvailable: '필터를 사용할 수 없습니다',
          value: '값',
          exportCSV: 'CSV 내보내기',
          show: '표시',
          loadMoreRecords: '기록 더 불러오기',
          selectedAllRecords: '전체 {{totalNum}}개 기록을 선택했습니다',
          selectedFromRecords: '{{totalNum}}개 기록 중 {{selectedNum}}개를 선택했습니다',
          reset: '재설정',
        },
        invalidColumn: '잘못된 열 {{column}}',
        assignedActionRecords: '할당된 조치 기록',
      },
      auth: {
        forgotPasswordView: {
          forgotYourPassword: '비밀번호를 잊으셨나요?',
          successMessage: '확인 이메일을 다음 주소로 보냈습니다:',
        },
        authSuccess: {
          thanks: '감사합니다!',
          backToLogin: '플랫폼으로 돌아가기',
        },
        loginView: {
          forgotPass: '비밀번호를 잊으셨나요?',
          createAccount: '계정 만들기',
          passwordIsRequired: '비밀번호는 필수 항목입니다',
          resetPassword: '비밀번호 재설정',
          contactSupport: 'support@prosaris.ca 로 문의해 주세요',
          incorrectEmailOrPassword: '이메일 또는 비밀번호가 올바르지 않습니다',
          resetPassDialog: {
            dialogOne: '계속하려면 비밀번호를 재설정해야 합니다.',
            dialogTwo: '비밀번호 재설정 안내가 포함된 이메일을 보내드렸습니다.',
          },
          ok: 'OK',
        },
        resetPasswordView: {
          passwordSuccessFullyReset: '비밀번호가 성공적으로 재설정되었습니다',
          enterNewPassword: '새 비밀번호를 아래에 입력해 주세요.',
          passwordChanged: '비밀번호가 변경되었습니다.',
        },
        createCompanyView: {
          companyName: '회사 이름',
          companyNameIsRequired: '회사 이름은 필수 항목입니다',
          successTitle: '축하합니다! {{companyName}} 계정이 성공적으로 생성되었습니다.',
          successDescription:
            '회사 계정이 생성되었습니다. 플랫폼에서 다른 팀원을 회사에 추가할 수 있습니다. 추가 문의 사항은 {{companyEmail}}로 연락해 주세요.',
          companySetup: '회사 설정',
          createCompany: '새 회사 만들기',
          createCompanyDescription:
            '{{companyName}} 플랫폼을 처음 사용하는 조직이라면, 이제 플랫폼에서 회사를 생성할 수 있습니다. 귀하는 회사 관리자 역할을 하게 됩니다.',
          or: '또는',
          joinExistingCompany: '기존 회사에 참여',
          joinExistingCompanyDescription:
            '{{companyName}} 플랫폼에 이미 등록된 회사 계정이 있고 해당 계정에 참여하려면, 아래 두 가지 옵션 중 하나를 선택하세요.',
          joinExistingCompanyOptions: {
            optionOne: '{{supportEmail}} 로 연락해 주세요. 담당 팀원이 원하는 회사에 추가해 드립니다.',
            optionTwo: '회사 관리자에게 문의하세요. 플랫폼에서 직접 초대를 보내드릴 수 있습니다.',
          },
          essentialRoleMessage:
            '귀하의 계정은 기본적으로 무료 Essential 등급에 속합니다. {{companyName}} 플랫폼의 다양한 등급에 대해 더 알아보려면 {{supportEmail}}로 문의해 주세요.',
          userRoleMessage: '또한 플랫폼에서 {{companyName}}의 사용자로 참여했습니다. 회사에 접속하려면 로그인하세요.',
        },
        amazonRegistration: {
          selectYourCompany: '회사를 선택하세요',
          selectCompanyDescription: '참여하려는 회사를 선택해 주세요.',
          searchCompanies: '회사 검색...',
          finishRegistration: '완료',
          cantFindCompany: '시설을 찾을 수 없나요?',
          cantFindCompanyStill: '도움이 필요하신가요?',
          cantFindCompanyDescription: '조직에 이미 등록된 회사 계정이 있고 그 계정에 참여하려면 아래 옵션 중 하나를 따르세요.',
          cantFindCompanyOptionOne: '<a href="mailto:{{supportEmail}}"><strong>{{supportEmail}}</strong></a>로 연락해 주세요.',
          companyRequired: '계속하려면 회사를 선택해 주세요',
          registrationSuccess: '계정이 성공적으로 생성되었습니다! 로그인해 주세요.',
          registrationError: '계정 생성에 실패했습니다. 다시 시도해 주세요.',
          back: '뒤로',
          addCompany: '시설 추가',
          addCompanyTitle: '새 시설 추가',
          addCompanyDescription: '모회사 아래에 새 시설을 생성합니다.',
          selectParentCompany: '모회사 선택',
          companyName: '시설 이름',
          companyNamePlaceholder: '예: YYZ1',
          companyNameHelperText: '3글자 시설 코드 뒤에 1-2자리 숫자를 입력하세요 (예: YYZ1)',
          validatingAirportCode: '시설 코드 확인 중...',
          invalidAirportCode: '시설 코드를 찾을 수 없습니다',
          networkError: '네트워크 오류. 다시 시도해 주세요.',
          validAirportCode: '{{municipality}}, {{country}}',
          companyNameRequired: '회사 이름은 필수입니다',
          parentCompanyRequired: '모회사는 필수입니다',
          invalidCompanyNameFormat: '회사 이름은 시설 코드 뒤에 1-2자리 숫자가 와야 합니다 (예: YYZ1, YYZ12)',
          createCompanySuccess: '회사 {{name}}이(가) 성공적으로 생성되었습니다!',
          createCompanyError: '회사 생성에 실패했습니다. 다시 시도해 주세요.',
          cannotSelectFacility: '시설 아래에는 회사를 생성할 수 없습니다. 모회사를 선택해 주세요.',
          pendingCompanySelected: '새 회사 "{{name}}"은(는) 등록을 완료하면 생성됩니다.',
        },
      },
      calculateLeak: {
        index: {
          loadingLeakError: '누출 데이터를 불러오는 중 예상치 못한 오류가 발생했습니다',
          calculatingError: '계산 중 예상치 못한 오류가 발생했습니다',
          dbMeasured: '측정된 dB',
          calculate: '계산',
          calculating: '계산 중...',
          outflowCoefficient: '유출 계수',
          kwhPerYear: '연간 kWh',
        },
      },
      companies: {
        commonUsedWords: {
          assignedAdminLicenses: '할당된 관리자 라이선스',
          company: '회사',
          totalAccounts: '총 계정 수',
          email: '이메일',
          name: '이름',
          loadCompanyUsersError: '회사 사용자를 불러오지 못했습니다. 나중에 다시 시도해 주세요',
          activated: '활성화됨',
          deactivated: '비활성화됨',
          activating: '활성화 중',
          deactivating: '비활성화 중',
          deactivate: '비활성화',
          activate: '활성화',
          set: '설정',
          youAreGoingTo: '다음 작업을 수행하려고 합니다',
          areYouSure: '정말 진행하시겠습니까?',
          companyNameIsRequired: '회사 이름은 필수 항목입니다',
          editCompany: '회사 편집',
          moveCompany: '회사 이동',
          createCompany: '회사 생성',
          viewHistory: '히스토리 보기',
          exportCSV: 'CSV 내보내기',
          onEssentialPlan: '현재 Essential 요금제를 사용 중입니다. support@prosaris.ca로 문의해 주세요',
        },
        hubspotTickets: {
          title: '온보딩 진행 상황',
          searchPlaceholder: '시설별 티켓 검색...',
          syncNow: '지금 동기화',
          syncing: '동기화 중...',
          syncTooltip: 'HubSpot에서 최신 파이프라인 단계 및 티켓을 가져옵니다',
          unmappedCompanies: '매핑되지 않은 회사',
          notStartedOnboarding: '온보딩 미시작',
          instructions: '다음은 PROSARIS 플랫폼에 해당 시설이 없는 HubSpot 티켓입니다. 매핑을 생성하려면 아래 단계를 따르세요:',
          step1: 'PROSARIS 플랫폼에서 새 시설 생성',
          step2Before: '',
          step2After: '버튼 클릭',
          noUnmappedTickets: '매핑되지 않은 티켓이 없습니다',
          noCompaniesWithoutOnboarding: '온보딩되지 않은 회사가 없습니다',
          noTicketsInStage: '이 단계에 티켓이 없습니다',
          loadingPipelines: '파이프라인 로딩 중...',
          loadingTickets: '티켓 로딩 중...',
          loadingCompanies: '회사 로딩 중...',
          errorLoadingPipelines: '파이프라인 로딩 오류',
          noPipelinesAvailable: '사용 가능한 파이프라인이 없습니다',
          noStagesAvailable: '사용 가능한 단계가 없습니다',
          lastUpdated: '마지막 업데이트: ',
          syncSuccess: 'HubSpot 데이터 동기화 성공',
          syncPipelineFailed: 'HubSpot 파이프라인 동기화 실패',
          syncTicketsFailed: 'HubSpot 티켓 동기화 실패',
        },
        accounts: {
          inviteUsers: {
            title: '{{companyName}}에 사용자 초대',
            emailAddresses: '사용자 이메일 주소',
            emailsRequired: '이메일이 필요합니다',
            successMessage: '사용자가 성공적으로 초대되었습니다',
            note: '이메일 주소를 줄바꿈하거나 쉼표로 구분해서 입력하세요.',
            tooltip: '각 사용자는 회사 초대장을 받게 됩니다.',
            invite: '초대',
          },
          accountDialog: {
            companyIsRequired: '회사는 필수 항목입니다',
            roleIsRequired: '역할은 필수 항목입니다',
            createAccountSuccessMessage: '계정이 성공적으로 생성되었습니다',
            emailTakenErrorMessage: '이 이메일을 가진 계정이 이미 존재합니다',
            errorWhileCreatingAccountMessage: '계정을 생성하는 동안 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
            changeAccountSuccessMessage: '계정이 성공적으로 업데이트되었습니다',
            errorWhileChangingAccountMessage: '계정을 업데이트하는 동안 오류가 발생했습니다. 다시 시도해 주세요.',
            editAccount: '계정 편집',
            createAccount: '계정 생성',
            role: '역할',
          },
          changeOwner: {
            changeOwnerMessage: '이 계정과 관련된 누출 기록의 소유자도 변경하시겠습니까?',
            no: '아니요, 현재 소유자를 유지합니다',
          },
          contentCell: {
            loadAccountRolesError: '계정 역할 정보를 불러오지 못했습니다. 나중에 다시 시도해 주세요.',
            changeRoleSuccessMessage: '계정 {{email}}에 새 역할이 지정되었습니다',
            changeRoleErrorMessage: '계정 {{email}}의 역할을 업데이트하는 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
            editUser: '사용자 편집',
            adminSetPassword: '관리자 비밀번호 설정',
            adminSetSubRenewalDate: '관리자 구독 갱신일 설정',
            resetPassword: '비밀번호 재설정',
            user: '사용자',
            deleteUser: '사용자 삭제',
          },
          index: {
            noUsersToDisplay: '표시할 사용자가 없습니다',
            changeStatusSuccessMessage: '사용자를 {{isActive}}했습니다',
            changeStatusErrorMessage: '사용자를 {{isActive}}하는 중 오류가 발생했습니다. 다시 시도해 주세요',
            changeOwnerSuccessMessage: '기록이 새 소유자에게 전송되었습니다',
            changeOwnerErrorMessage: '기록을 새 소유자에게 전송할 수 없습니다. 나중에 다시 시도해 주세요',
            deleteAccountMutationSuccessMessage: '계정 {{email}}이 성공적으로 삭제되었습니다',
            deleteAccountMutationErrorMessage: '현재 계정 {{email}}을 삭제할 수 없습니다. 나중에 다시 시도해 주세요',
            resetAccountPassWordSuccessMessage: '비밀번호 재설정 이메일이 성공적으로 전송되었습니다.',
            users: '사용자',
            noneAvailable: '없음',
            of: '/',
            contactSupport: '회사 관리자 라이선스에 대한 추가 정보는 support@prosaris.ca로 문의해 주세요',
            findAccount: '계정 찾기',
            placeholder: '이름 또는 이메일을 입력하세요...',
            tooltip: '사용자를 초대하려면 최소 하나의 회사 관리자 라이선스가 필요합니다',
            invite: '초대',
            alertDialog: {
              messageOne: '사용자의 비밀번호 재설정 요청을 확인해 주세요',
              messageTwo: '계정 상태 변경을 확인해 주세요',
              messageThree: '계정 삭제를 확인해 주세요',
            },
            sendAPasswordResetEmail: '다음 계정에 비밀번호 재설정 이메일을 보내려 합니다:',
            confirmMessage: '계속하시겠습니까?',
            followingAccount: '다음 계정:',
            delete: '삭제',
            userCreatedDialogTitle: '사용자 비밀번호 재설정 링크가 전송되었습니다',
            userCreatedDialogDescription: '사용자에게 비밀번호 재설정 링크가 이메일로 전송되었습니다. 아래 링크를 복사할 수도 있습니다.',
          },
          adminSetPassword: {
            changedUserPasswordSuccessMessage: '계정 비밀번호가 성공적으로 업데이트되었습니다',
            changedUserPasswordErrorMessage: '계정을 업데이트하는 중 오류가 발생했습니다. 다시 시도해 주세요.',
            setNewPassword: '새 비밀번호 설정',
            accountPasswordUpdated: '계정 비밀번호가 업데이트되었습니다',
            accountPasswordUpdatedDescription:
              '계정 비밀번호가 성공적으로 업데이트되었습니다. 아래 버튼을 클릭하면 새 비밀번호를 복사할 수 있습니다.',
          },
          adminSetSubRenewalDate: {
            title: '구독 갱신일 설정',
            subRenewalDate: '구독 갱신일',
            changedSubRenewalDateSuccessMessage: '구독 갱신일이 성공적으로 업데이트되었습니다',
            changedSubRenewalDateErrorMessage: '계정을 업데이트하는 중 오류가 발생했습니다. 다시 시도해 주세요.',
          },
          setPassword: {
            automatic: '강력한 비밀번호 자동 생성',
            manual: '비밀번호 직접 생성',
            copyLinkInstruction: '다음 단계에서 비밀번호를 확인하고 복사할 수 있습니다',
          },
          userCreatedDialog: {
            title: '사용자가 성공적으로 생성되었습니다',
            description: '새 사용자가 이제 플랫폼을 사용할 수 있습니다. 사용자에게 이메일로 비밀번호 재설정 링크도 전송됩니다.',
            passwordCopied: '비밀번호가 클립보드에 복사되었습니다',
            passwordResetLinkCopied: '비밀번호 재설정 링크가 클립보드에 복사되었습니다',
            copyPassword: '비밀번호 복사',
            copyPasswordResetLink: '비밀번호 재설정 링크 복사',
          },
          useRoleOptions: {
            notAvailable: '(사용 불가)',
            adminSeatTaken: '(관리자 좌석이 사용 중입니다)',
            allSeatsAreTaken: '(총 {{numSeats}}석이 모두 사용 중입니다)',
            adminRolesTitle: '관리자 역할',
            roles: {
              superAdmin: '루트 관리자',
              companyAdmin: '회사 (관리자)',
              superCompanyAdmin: '법인 (관리자)',
              companyRead: '회사 (읽기)',
              superAdminRead: '루트 관리자 (읽기)',
              integrator: '통합 담당자',
              auditor: '감사자',
              user: '사용자',
              essential: 'Prosaris Essential',
              enterpriseAdmin: '엔터프라이즈 관리자',
            },
            rolesDescriptions: {
              superAdmin: '여러 회사를 완전히 관리할 수 있습니다.',
              companyAdmin: '회사 기록을 보고, 편집하고, 할당할 수 있습니다.',
              superCompanyAdmin: '회사 기록과 사용자를 완전히 관리할 수 있습니다.',
              companyRead: '회사 기록을 읽기 전용으로 볼 수 있습니다.',
              superAdminRead: '모든 회사에 읽기 전용으로 접근할 수 있습니다.',
              integrator: '타사 통합이 회사와 계정을 관리할 수 있습니다.',
              auditor: '누출 기록을 감사할 수 있습니다.',
              user: '본인의 기록을 생성/수정/삭제할 수 있습니다.',
              essential: '기능이 제한된 역할입니다.',
              enterpriseAdmin: '엔터프라이즈 전체를 완전히 제어할 수 있습니다.',
            },
            nonAdminRolesTitle: '비관리자 역할',
          },
        },
        audits: {
          index: {
            loadAuditsErrorMessage: '감사 데이터를 불러오는 데 실패했습니다. 나중에 다시 시도해 주세요',
            audits: '감사',
            noAuditsToDisplay: '표시할 감사가 없습니다',
            findByAuditorEmail: '감사자 이메일로 찾기',
            placeholder: '감사자 이메일을 입력하세요...',
          },
        },
        companyTabs: {
          recordLock: {
            message: '이 기능의 잠금을 해제하려면 기록을 생성하여 플랫폼에 업로드하세요.',
          },
          facility: {
            index: {
              facilityNameIsRequired: '시설 이름은 필수 항목입니다',
              hoursYearlyIsRequired: '연간 총 시간은 필수 항목입니다',
              totalHoursYearly: '연간 총 시간은 8760을 초과할 수 없습니다',
              invalidPhoneNumber: '잘못된 전화번호입니다',
              createErrorMessage: '시간 × 교대는 24시간을 초과할 수 없습니다',
              loadFacilityErrorMessage: '시설을 불러오지 못했습니다. 나중에 다시 시도해 주세요',
              createFacilitySuccessMessage: '시설이 성공적으로 생성되었습니다',
              createFacilityErrorMessage: '시설 생성 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
              changeFacilitySuccessMessage: '시설이 성공적으로 업데이트되었습니다',
              changeFacilityErrorMessage: '시설 업데이트 중 오류가 발생했습니다. 다시 시도해 주세요.',
              facilityName: '시설 이름',
              abbreviation: '약어',
              address: '주소',
              enterALocation: '위치를 입력하세요',
              tooltip: '에너지 관리 활동 및 보고서 승인용',
              energyMgtOwner: '에너지 관리 책임자',
              title: '직함',
              phone: '전화번호',
              tooltipTwo: '솔루션 갱신 및 일반 계정 문제용',
              accountOwner: '계정 책임자',
              manufacturingArea: '제조 구역',
              size: '규모',
              unit: '단위',
              hoursOfOperation: '운영 시간',
              auditFrequency: '감사 주기',
            },
            operationHours: {
              daysPerWeek: '주당 일수',
              shiftsPerDay: '일일 교대 수',
              hoursPerShift: '교대당 시간',
              weeksPerYear: '연 52주',
              totalHoursYearly: '총합 = 연간 시간',
            },
            constants: {
              constant: '고정',
              monthly: '월간',
              threeMonth: '3개월',
              fourMonth: '4개월',
              sixMonth: '6개월',
              nineMonth: '9개월',
              annual: '연간',
              sqft: '제곱피트 [SQFT]',
              sqm: '제곱미터 [SQM]',
            },
          },
          index: {
            users: '사용자',
            devices: '디바이스',
            facility: '시설',
            energy: '에너지',
            seu: 'SEU - 압축기',
            enpi: 'EnPI/EnB',
            routes: '경로',
            audit: '감사',
            comingSoon: '곧 제공 예정...',
          },
        },
        enpis: {
          index: {
            loadEnpisErrorMessage: 'EnPI를 불러오는 데 실패했습니다. 나중에 다시 시도해 주세요',
            createEnpisSuccessMessage: 'EnPI가 성공적으로 생성되었습니다',
            createEnpisErrorMessage: 'EnPI 생성 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
            changeEnpisSuccessMessage: 'EnPI가 성공적으로 업데이트되었습니다',
            changeEnpisErrorMessage: 'EnPI 업데이트 중 오류가 발생했습니다. 다시 시도해 주세요.',
            showHistory: '히스토리 보기',
          },
        },
        changeHistory: {
          bulkOperation: '일괄 작업',
          details: '세부 정보',
          created: '생성됨',
          updated: '업데이트됨',
          componentTypes: {
            enpis: 'EnPI',
            company: '회사',
          },
          history: '히스토리',
          noHistory: '히스토리가 없습니다',
        },
        energy: {
          index: {
            utilProvider: '전력 공급업체',
            energyUse: '에너지 사용 및 소비 유형',
            error: {
              loadFacility: '시설을 불러오는 데 실패했습니다. 나중에 다시 시도해 주세요',
              loadEnergy: '에너지 데이터를 불러오는 데 실패했습니다. 나중에 다시 시도해 주세요',
              loadUtilProviderLogo: '전력 공급업체 로고를 불러오는 데 실패했습니다. 나중에 다시 시도해 주세요',
              createEnergy: '에너지 데이터를 생성하지 못했습니다. 나중에 다시 시도해 주세요',
              createUtilProviderLogo: '전력 공급업체 로고 업로드에 실패했습니다. 나중에 다시 시도해 주세요',
              updateEnergy: '에너지 데이터를 업데이트하지 못했습니다. 나중에 다시 시도해 주세요',
              deleteUtilProviderLogo: '전력 공급업체 로고 삭제에 실패했습니다. 나중에 다시 시도해 주세요',
            },
            success: {
              createEnergy: '에너지 데이터가 성공적으로 생성되었습니다',
              updateEnergy: '에너지 데이터가 성공적으로 업데이트되었습니다',
            },
          },
          utilProvider: {
            index: {
              costOfEnergy: '에너지 비용',
              incentiveRate: '인센티브 요율',
              energySources: '에너지 원',
              per: '당',
              validations: {
                utilProviderIsRequired: '전력 공급업체는 필수 항목입니다',
                costOfEnergyIsRequired: '에너지 비용은 필수 항목입니다',
                costOfEnergyMustBeNumber: '에너지 비용은 숫자여야 합니다',
                costOfEnergyMustBeGreaterThanZero: '에너지 비용은 0보다 커야 합니다',
                costOfRebateMustBeAtLeatZero: '리베이트 비용은 최소 0이어야 합니다',
                costOfRebateMustBeNumber: '리베이트 비용은 숫자여야 합니다',
              },
            },
            UtilProviderLogo: {
              error: {
                fileSize: '파일 크기는 1MB 미만이어야 합니다',
                preview: '이미지를 미리 볼 수 없습니다',
              },
              logo: '로고',
              addLogo: '로고 추가',
              removeLogo: '로고 제거',
            },
            EnergySources: {
              energySource: '에너지 원',
              percentage: '비율',
              selectEnergySource: '에너지 원 선택',
              addEnergySource: '에너지 원 추가',
              totalPercentage: '총 비율',
              mustBeEqualTo100: '(총합 100%여야 함)',
              constants: {
                energySources: {
                  NATURAL_GAS: '천연가스',
                  FUEL_OIL: '연료유',
                  DIESEL: '디젤',
                  GASOLINE: '휘발유',
                  PROPANE: '프로판',
                  COAL: '석탄',
                  WIND: '풍력',
                  GEOTHERMAL: '지열',
                  BIOMASS: '바이오매스',
                  STEAM: '스팀',
                  COMPRESSED_AIR: '압축 공기',
                  CHILLED_WATER: '냉각수',
                  NUCLEAR: '원자력',
                  HYDRO: '수력',
                  SOLAR: '태양광',
                },
              },
            },
          },
          energyUse: {
            index: {
              currentCalcApproach: '현재 계산 방식',
              currentCalcApproachMessage: "이 계산 방식은 사용자가 변경하지 않는 한 모든 '에너지 비용' 필드에 기본적으로 적용됩니다.",
              alertTitle: '계산 방식 재설정',
              alertMessageOne: "이 작업을 수행하면 앞으로 모든 '에너지 비용' 필드에서 현재 계산 방식을 사용하지 않게 됩니다.",
              alertMessageTwo: '이 변경은 기존 기록에는 영향을 미치지 않습니다.',
              alertMessageThree: '정말로 재설정하시겠습니까?',
            },
            ReportType: {
              calcApproach: '계산 방식',
              constants: {
                calculations: {
                  FIXED: '고정 효율',
                  USDOE: 'US DoE',
                  NREL: 'NREL 22장',
                },
              },
              setAsCurrent: '현재 방식으로 설정',
              setAsCurrentMessage: "앞으로 모든 '에너지 비용' 필드에 이 계산 방식이 적용됩니다.",
            },
            calculations: {
              FixedEfficiency: {
                validations: {
                  efficiencyMustBeGreaterThanZero: '효율은 0 이상이어야 합니다',
                  efficiencyMustBeNumber: '효율은 숫자여야 합니다',
                  operationHoursMustBeGreaterThanZero: '운영 시간은 0 이상이어야 합니다',
                  operationHoursMustBeLessThan8760: '운영 시간은 8760 미만이어야 합니다',
                  operationHoursMustBeNumber: '운영 시간은 숫자여야 합니다',
                },
              },
              UsDoe: {
                loaded: '부하 상태',
                unloaded: '무부하 상태',
                calcSummary: '계산 요약',
                currentOperatingSystems: '현재 운영 시스템',
                noCompsFoundAddCompOne: '컴프레서를 찾을 수 없습니다. 위의',
                noCompsFoundAddCompTwo: '탭에서 컴프레서를 추가하세요.',
                help: {
                  nameplateHpPath: '파생 출처: SEU - 압축기 → 컴프레서 설계 데이터 → {compressorTag} → 명판 HP',
                  nameplateCapacityPath: '파생 출처: SEU - 압축기 → 컴프레서 설계 데이터 → {compressorTag} → 명판 용량',
                  motorEfficiencyPath: '파생 출처: SEU - 압축기 → 컴프레서 설계 데이터 → {compressorTag} → 모터 효율',
                  pressureSetpointPath: '파생 출처: SEU - 압축기 → 컴프레서 설계 데이터 → {compressorTag} → 압력 설정값',
                  operatingHoursPath: '기본값 출처: 시설 → 운영 시간',
                  aggregateElectricRatePath: '파생 출처: 에너지 → 전력 공급업체 → 에너지 비용',
                  loadedAutoFromUnloaded: '무부하에서 자동',
                  unloadedAutoFromLoaded: '부하에서 자동',
                },
              },
            },
          },
        },
        compressors: {
          compressorDialog: {
            plateError: '명판 업로드 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
            dataSheetError: '데이터 시트 업로드 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
            createSuccess: '컴프레서 {{tag}}이(가) 생성되었습니다',
            createError: '컴프레서를 생성하지 못했습니다. 나중에 다시 시도해 주세요.',
            createCompressor: '컴프레서 추가',
            selectTemplate: '컴프레서를 선택하세요...',
            templatesError: '컴프레서 조회를 불러오지 못했습니다. 나중에 다시 시도해 주세요.',
            searchPlaceholder: '모델 또는 제조사로 검색... (예: G11-100, Atlas Copco)',
            templateDescription:
              '로터리 스크류 컴프레서는 사용 가능한 목록에서 선택하거나 정보를 직접 입력하여 추가할 수 있습니다. 목록에서 선택하면 나머지 정보가 자동으로 채워집니다. 나중에 세부 정보를 조정할수 있습니다. 왕복 및 원심 컴프레서는 수동 입력이 필요합니다.',
            quickSelect: '빠른 선택',
            quickSelectDescription: '기존 컴프레서 조회에서 선택',
            basicInfo: '기본 정보',
            basicInfoDescription: '컴프레서 식별 기본 정보',
            technicalSpecifications: '기술 사양',
            technicalSpecificationsDescription: '성능 및 운영 파라미터',
            documentation: '문서',
            documentationDescription: '컴프레서 파일과 문서를 업로드하세요',
            compressorSpecifications: '컴프레서 사양',
            nameplate: '명판',
            motor: '모터',
            fullLoad: '정격 부하',
            pressure: '압력',
            other: '기타',
            compressorFiles: '컴프레서 파일',
            datasheetDisplayError: '데이터 시트를 표시하지 못했습니다',
            datasheetProcessError: '데이터 시트를 처리하지 못했습니다',
          },
          compressorFile: {
            tip: '파일 추가',
            removeFile: '파일 제거',
            removeImage: '이미지 제거',
            title: '컴프레서 {{prop}} 삭제를 확인해 주세요',
            proceed: '계속하시겠습니까?',
          },
          compressorForm: {
            compTagIsReq: '컴프레서 태그는 필수 항목입니다',
            controlIsReq: '제어 방식은 필수 항목입니다',
            hpMustBeNum: '명판 HP는 숫자여야 합니다',
            capMustBeNum: '명판 용량은 숫자여야 합니다',
            motorEffMustBeNum: '모터 효율은 숫자여야 합니다',
            motorVoltMustBeNum: '모터 전압은 숫자여야 합니다',
            loadMustBeNum: '정격 부하 전류는 숫자여야 합니다',
            loadInputMustBeNum: '정격 부하 입력 전력은 숫자여야 합니다',
            pressureMustBeNum: '정격 압력은 숫자여야 합니다',
            setpointMustBeNum: '압력 설정값은 숫자여야 합니다',
            airMustBeNum: '총 공기 저장 용량은 숫자여야 합니다',
            addImage: '이미지 추가',
            addFile: '파일 추가',
          },
          constants: {
            compressorTypes: {
              ROTARY_SCREW: '로터리 스크류',
              RECIPROCATING: '왕복',
              CENTRIFUGAL: '원심',
            },
            rotaryScrew: {
              loadUnloadOilFree: '부하/무부하 – 오일 프리',
              loadUnload1Gal: '부하/무부하 (1 gal/CFM)',
              loadUnload3Gal: '부하/무부하 (3 gal/CFM)',
              loadUnload5Gal: '부하/무부하 (5 gal/CFM)',
              loadUnload10Gal: '부하/무부하 (10 gal/CFM)',
              ivmWithBlowdown: '흡입 밸브 조절 (블로우다운 없음)',
              ivmWithoutBlowdown: '흡입 밸브 조절 (블로우다운 포함)',
              variableDisplacement: '가변 용량',
              vsdWithUnloading: 'VSD (무부하 포함)',
              vsdWithStopping: 'VSD (정지 포함)',
            },
            reciprocating: {
              reciprocatingOnOffControl: '온/오프 제어',
              reciprocatingLoadUnload: '부하/무부하',
            },
            centrifugal: {
              centrifugalInletIgv: 'IBV (블로우다운 포함)',
              centrifugalInletIbv: 'IGV (블로우다운 포함)',
            },
          },
          contentCell: {
            min: '%는 최소 0이어야 합니다',
            max: '%는 100을 초과할 수 없습니다',
            max150: '%는 150을 초과할 수 없습니다',
            typeError: '부하는 유효한 퍼센트여야 합니다',
            setpointMustBeNum: '컴프레서 설정값은 숫자여야 합니다',
            flowMustBeNum: '컴프레서 유량은 숫자여야 합니다',
            pressureSetpointMustBeNum: '시스템 압력 설정값은 숫자여야 합니다',
            measuredFlowMustBeNum: '시스템 측정 유량은 숫자여야 합니다',
            dateTime: '날짜 및 시간 선택',
            active: '가동 중',
            off: '정지',
            trim: '트림',
            baseLoad: '기준 부하',
          },
          index: {
            error: '컴프레서를 불러오지 못했습니다. 나중에 다시 시도해 주세요',
            nameplateError: '명판을 불러오지 못했습니다. 나중에 다시 시도해 주세요',
            dataSheetError: '데이터 시트를 불러오지 못했습니다. 나중에 다시 시도해 주세요',
            changeCompSuccess: '컴프레서가 성공적으로 업데이트되었습니다',
            changeCompError: '컴프레서를 업데이트하는 중 오류가 발생했습니다. 다시 시도해 주세요.',
            deleteCompSuccess: '컴프레서가 성공적으로 삭제되었습니다',
            deleteCompError: '컴프레서를 삭제하는 중 오류가 발생했습니다. 다시 시도해 주세요.',
            createCompNameplateSuccess: '컴프레서 명판이 성공적으로 업로드되었습니다',
            createCompNameplateError: '명판 업로드 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
            deleteCompNameplateSuccess: '컴프레서 명판이 성공적으로 삭제되었습니다',
            deleteCompNameplateError: '컴프레서 명판 삭제 중 오류가 발생했습니다. 다시 시도해 주세요.',
            createCompDataSheetSuccess: '컴프레서 데이터 시트가 성공적으로 업로드되었습니다',
            createCompDataSheetError: '데이터 시트 업로드 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
            deleteCompDataSheetSuccess: '컴프레서 데이터 시트가 성공적으로 삭제되었습니다',
            deleteCompDataSheetError: '컴프레서 데이터 시트 삭제 중 오류가 발생했습니다. 다시 시도해 주세요.',
            changeCompanyCompSuccess: '시스템 데이터가 성공적으로 업데이트되었습니다',
            changeCompanyCompError: '시스템 데이터를 업데이트하는 중 오류가 발생했습니다. 다시 시도해 주세요.',
            compDesignData: '컴프레서 설계 데이터',
            comp: '컴프레서:',
            addComp: '컴프레서 추가',
            editCompPermission: '컴프레서를 편집하려면 관리자 라이선스가 필요합니다. 문의:',
            selectOption: '옵션 선택',
            undoChanges: '변경 취소',
            selectComp: '위에서 컴프레서를 선택하세요.',
            noCompsFound: '컴프레서를 찾을 수 없습니다.',
            compRunningState: '컴프레서 가동 상태',
            compRunningStateLogs: 'Compressor Running State Logs',
            hiddenCompressors: 'Hidden compressors',
            hiddenCompressorsCount: '{{count}} hidden',
            showHiddenCompressors: 'Show {{count}} deleted',
            hideHiddenCompressors: 'Hide {{count}} deleted',
            saveRunningState: 'Save running state',
            discardChanges: 'Discard changes',
            runningStateDirty: 'You have unsaved changes.',
            unsavedChangesConfirm: 'Discard your unsaved changes?',
            compressorDeleted: 'Deleted',
            snapshotHistoryEmpty: 'No earlier states yet — changes will appear here.',
            snapshotHistoryColumnTimestamp: 'Timestamp',
            snapshotHistoryColumnStatus: 'Status',
            snapshotHistoryColumnTrigger: 'Change',
            snapshotStatus: '{{active}}/{{total}} compressors active',
            snapshotGroupToday: 'Today',
            snapshotGroupYesterday: 'Yesterday',
            snapshotCurrent: 'Current',
            snapshotCurrentSubtitle: 'Live state',
            snapshotTrigger: {
              create: 'Created',
              update: 'Edited',
              delete: 'Deleted',
              companyEdit: 'System update',
              backfill: 'Initial state',
            },
            viewingSnapshotPrefix: 'Viewing snapshot from',
            returnToCurrent: 'Return to current',
            noCompsFoundAddComp: '컴프레서를 찾을 수 없습니다. 위 섹션에서 컴프레서를 추가하세요.',
            title: '컴프레서 삭제를 확인해 주세요',
            areYouSure: '정말로',
            compressor: '컴프레서를',
            delete: '삭제하시겠습니까?',
          },
        },
        devices: {
          contentCell: {
            device: '디바이스',
            usedByMultipleCompanies: '여러 회사에서 사용 중입니다',
          },
          index: {
            noDevicesToDisplay: '이 회사에서 기록을 남긴 디바이스가 없습니다',
            loadingDevicesErrorMessage: '회사 디바이스를 불러오지 못했습니다. 나중에 다시 시도해 주세요',
            changeStatusSuccessMessage: '디바이스를 {{isActive}} 상태로 변경했습니다',
            changeStatusErrorMessage: '디바이스를 {{isActive}} 상태로 변경하는 중 오류가 발생했습니다. 다시 시도해 주세요',
            devices: '디바이스',
            findDevice: '디바이스 찾기',
            placeholder: '디바이스 ID를 입력하세요...',
            activatedOn: '활성화일',
            title: '디바이스 상태 변경을 확인해 주세요',
          },
        },
        company: {
          deleteCompanySuccessMessage: '{{companyName}}이(가) 성공적으로 삭제되었습니다',
          deleteCompanyErrorMessage: '{{companyName}}을(를) 삭제하지 못했습니다. 나중에 다시 시도해 주세요.',
          needAdminLicense: '이 기능에 접근하려면 관리자 라이선스가 필요합니다. support@prosaris.ca로 문의해 주세요',
          deleteChildCompanyFirst: '하위 회사나 계정이 있는 회사는 삭제할 수 없습니다. 먼저 모든 하위 회사와 계정을 삭제하세요.',
          editSettings: '설정 편집',
          createASubCompany: '{{companyName}}의 하위 회사 만들기',
          deleteCompany: '회사 삭제',
          cannotCreateChildCompanyDialog: {
            messageOne: '기업 계정으로 생성할 수 있는 회사 수의 최대치에 도달했습니다. 자세한 내용은',
            messageTwo: '로 문의하세요.',
          },
          deleteCompanyDialog: {
            title: '회사 삭제를 확인해 주세요',
            delete: '삭제',
            deleting: '삭제 중',
            permanentlyDeleted: '를(을) 삭제하면 데이터베이스에서 영구적으로 제거됩니다.',
            cannotBeUndone: '이 작업은 되돌릴 수 없습니다.',
          },
        },
        companyDialog: {
          industryIsRequired: '산업군은 필수 항목입니다',
          createLogoErroerMessage: '이미지 업로드 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
          deleteLogoErrorMessage: '이미지 삭제 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
          createCompanySuccessMessage: '회사 {{name}}이(가) 생성되었습니다',
          createCompanyErrorMessage: '회사를 생성하지 못했습니다. 나중에 다시 시도해 주세요.',
          changeCompanySuccessMessage: '회사 {{name}}이(가) 업데이트되었습니다',
          changeCompanyErrorMessage: '회사 정보를 변경하지 못했습니다. 나중에 다시 시도해 주세요.',
          language: '언어',
          industry: '산업',
          country: '국가',
          currency: '통화',
        },
        companyLogo: {
          setImageErrorMessage: '파일 크기는 1MB 미만이어야 합니다',
          logo: '로고',
          add: '추가',
          removeLogo: '로고 제거',
          addLogo: '로고 추가',
        },
        index: {
          loadCompaniesErrorMessage: '회사 목록을 불러오지 못했습니다. 나중에 다시 시도해 주세요',
          loadAccountsErrorMessage: '계정 목록을 불러오지 못했습니다. 나중에 다시 시도해 주세요',
          changeCompaniesSectionWidth: '회사 섹션 너비 변경',
        },
        sidebar: {
          filterCompanies: '회사 필터',
          enterAtLeastNChatacters: '{{length}}자 이상 입력하세요',
          placeholder: '회사 또는 이메일 입력',
          myCompany: '내 회사',
          childCompanies: '하위 회사',
          moreCompany: '{{count}}개 회사 더',
          moreCompanies: '{{count}}개 회사 더',
        },
        routes: {
          commonUsedWords: {
            equipmentNameIsRequired: '장비 이름은 필수 항목입니다',
            equipmentLocationIsRequired: '장비 위치는 필수 항목입니다',
            equipmentCriticalityIsRequired: '장비 중요도는 필수 항목입니다',
            equipmentDescriptionIsRequired: '장비 설명은 필수 항목입니다',
            name: '이름',
            description: '설명',
            location: '위치',
            criticality: '중요도',
            actions: '작업',
          },
          index: {
            routePlans: '경로 계획',
            addRoute: '경로 추가',
            routeRoutesExample: '경로 예시',
            pieceOfEquipment: '장비 {{count}}개',
            piecesOfEquipment: '장비 {{count}}개',
            equipment: '장비',
            metrics: '지표',
            settings: '설정',
            noFloorPlan: '이 경로에는 업로드된 평면도가 없습니다',
            addFloorPlan: '평면도를 추가해 경로를 시각적으로 계획하세요',
            routeEquipment: '경로 장비',
            routeMetrics: '경로 지표',
            metricsForRoute: '경로 지표',
            totalRecords: '총 기록',
            totalOpenRecords: '미완료 기록 수',
            totalClosedRecords: '완료 기록 수',
            totalLossPerYear: '연간 총 손실',
            totalKwhPerYear: '연간 총 kWh',
            routeUpdatedSuccessfully: '경로가 성공적으로 업데이트되었습니다',
            routeRemovedSuccessfully: '경로가 성공적으로 삭제되었습니다',
            routeSettings: '경로 설정',
            removeRoute: '경로 제거',
            deleteRouteWarning:
              '이 경로를 삭제하면 경로, 경로 장비, 경로 이력이 시스템에서 제거되지만, 기록에 연결된 과거 데이터는 유지됩니다.',
            areYouSure: '정말 이 경로를 제거하시겠습니까?',
            warningRemovingRoute: '경로를 제거하면 해당 경로와 장비, 히스토리가 시스템에서 영구적으로 삭제됩니다.',
            thisActionCannotBeUndone: '이 작업은 되돌릴 수 없습니다.',
            noFacility: '정의된 시설이 없습니다',
            createAFacility: '경로 계획을 시작하려면 시설을 생성하세요',
            goToCreateAFacility: '시설 생성으로 이동',
            createAFacilityTooltip: '경로를 계획하려면 먼저 시설을 생성해야 합니다.',
          },
          routeBuilder: {
            title: '경로 빌더',
            missingFields: '업로드된 파일에 누락된 항목이 있습니다',
            facility: '시설',
            route: '경로',
            enterRoute: '경로 입력',
            addFloorplan: '평면도 추가',
            floorplanInstructionsTooltip: '평면도 이미지를 추가해 경로를 구축하세요. 저장하면 경로가 평면도 위에 겹쳐집니다.',
            change: '변경',
            location: '위치',
            enterLocation: '위치 입력',
            equipment: '장비',
            enterEquipment: '장비 입력',
            criticality: '중요도',
            enterCriticality: '중요도 입력',
            description: '설명',
            enterDescription: '설명 입력',
            addEquipment: '장비 추가',
            addRoute: '경로 추가',
            downloadTemplate: '템플릿 다운로드',
            excelTemplate: '엑셀 템플릿 (.xlsx)',
            csvTemplate: 'CSV 템플릿 (.csv)',
          },
          fileReader: {
            loadFromFile: '파일에서 불러오기',
            instructionsTooltip:
              '엑셀(.xlsx, .xls) 또는 CSV(.csv) 파일을 업로드해 장비를 가져올 수 있습니다. 파일에는 equipment_name, equipment_location, equipment_criticality, equipment_description 열이 있어야 합니다. 제공된 템플릿을 다운로드해 시작하세요.',
          },
          addRouteModal: {
            addRouteFor: '{{facilityName}}에 경로 추가',
            giveYourNewRouteAName: '새 경로에 이름을 지정하고 시설 내 위치를 설명한 다음 첫 번째 장비를 추가하세요',
            routeNameIsRequired: '경로 이름은 필수 항목입니다',
            routeLocationIsRequired: '경로 위치는 필수 항목입니다',
            routeName: '경로 이름',
            routeLocation: '경로 위치',
            firstPieceOfEquipment: '첫 번째 장비',
            equipmentName: '장비 이름',
            equipmentCriticality: '장비 중요도',
            equipmentLocation: '장비 위치',
            equipmentDescription: '장비 설명',
            locationTooltip: '시설 내 위치를 설명하세요',
            equipmentLocationTooltip: '경로 내 위치를 설명하세요',
            criticalityTooltip: '장비 중요도 등급(ECR)을 지정하세요 (일반적으로 1~5)',
            downloadTemplate: '템플릿 다운로드',
            downloadCsvTemplate: 'CSV 템플릿 다운로드',
            downloadExcelTemplate: '엑셀 템플릿 다운로드',
            manual: '수동',
            import: '가져오기',
            importedEquipments: '가져온 장비',
            pleaseImportEquipment: '장비를 가져오거나 수동 모드로 전환하세요',
            equipmentOrderNote: '파일에 나타나는 순서대로 장비가 경로에 추가됩니다.',
            addFloorplan: '평면도 추가',
            change: '변경',
            floorplan: '평면도',
            noValidEquipmentDataFound: '파일에 유효한 장비 데이터를 찾지 못했습니다. 템플릿을 확인하세요.',
            equipmentItemsImportedSuccessfully: '장비 {{count}}개가 성공적으로 가져와졌습니다',
            invalidFileFormat: '잘못된 파일 형식입니다. 제공된 템플릿을 사용하세요.',
            floorplanUploadedSuccessfully: '평면도가 성공적으로 업로드되었습니다',
            routeCreatedSuccessfully: '경로가 성공적으로 생성되었습니다',
            equipment: '장비',
            equipments: '장비',
            addEquipmentBefore: '이전 장비 추가',
            addEquipmentAfter: '다음 장비 추가',
            addEquipmentBetween: '중간에 장비 추가',
            removeEquipment: '장비 제거',
            floorplanIsRequired: '평면도는 필수 항목입니다',
          },
          routeViewer: {
            showLabels: '라벨 표시',
            hideLabels: '라벨 숨기기',
            showNumbers: '번호 표시',
            hideNumbers: '번호 숨기기',
            markerSize: '마커 크기',
            routeOpacity: '경로 불투명도',
            zoomIn: '확대',
            zoomOut: '축소',
            resetZoom: '줌 초기화',
            centerView: '뷰 가운데로',
            panUp: '위로',
            panDown: '아래로',
            panLeft: '왼쪽으로',
            panRight: '오른쪽으로',
            expandControls: '컨트롤 표시',
            collapseControls: '컨트롤 숨기기',
          },
          routeEditorAddEquipmentAction: {
            addingNewEquipment: '새 장비를 추가하면 선택된 장비 뒤에 경로에 배치됩니다.',
            addEquipment: '장비 추가',
          },
          routeEditorAddWaypointAction: {
            waypoint: '웨이포인트',
            addingNewWaypoint:
              '새 웨이포인트를 추가하면 선택된 장비 뒤에 경로 방향 전환이 추가되지만 경로 실행 단계에는 포함되지 않습니다.',
            addWaypoint: '웨이포인트 추가',
          },
          routeEditorEditEquipmentAction: {
            updateEquipment: '장비 업데이트',
          },
          routeEditorEditFloorPlan: {
            floorPlan: '평면도',
            chooseFloorplan: '평면도 선택',
          },
          routeEditorModal: {
            successRouteUpdated: '경로가 성공적으로 업데이트되었습니다',
            errorRouteUpdated: '경로를 업데이트하는 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
            successRouteDeleted: '경로가 성공적으로 삭제되었습니다',
            errorRouteDeleted: '경로를 삭제하는 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
            successFloorplanUpdated: '평면도가 성공적으로 업데이트되었습니다',
            errorFloorplanUpdated: '평면도를 업데이트하는 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
            unsavedChanges: '저장되지 않은 변경 사항이 있습니다. 정말 나가시겠습니까?',
            back: '뒤로',
            editEquipment: '장비 편집',
            youHaventUploadedFloorPlan: '아직 평면도를 업로드하지 않았습니다. 지금 평면도를 업로드하여 시각적 편집을 사용하세요.',
            addFloorPlan: '평면도 추가',
            addNewEquipment: '새 장비 추가',
            removeEquipment: '장비 제거',
            swapEquipment: '장비 교체',
            addWaypoint: '웨이포인트 추가',
            changeFloorplan: '평면도 변경',
            actions: {
              ADD_EQUIPMENT: '장비 추가',
              DELETE_NODE: '노드 삭제',
              SWAP_EQUIPMENT: '장비 교체',
              ADD_WAYPOINT: '웨이포인트 추가',
              CHANGE_FLOORPLAN: '평면도 변경',
            },
          },
          routeEditorRemoveEquipmentAction: {
            youAreAboutToRemoveEquipmentFromTheRoute: '다음 장비를 경로에서 제거하려고 합니다.',
            youAreAboutToRemoveWaypointFromTheRoute: '선택된 웨이포인트를 경로에서 제거하려고 합니다.',
            youWillNotLoseAnyHistoricalData:
              '기록된 데이터는 유지되지만 이 {{type}}는 경로에서 제거되어 향후 경로 실행에서 사용할 수 없습니다.',
            equipment: '장비',
            waypoint: '웨이포인트',
          },
          routeEditorSwapEquipmentAction: {
            replacementEquipmentIsRequired: '교체할 장비를 선택해야 합니다',
            swappingEquipmentExplanation: '장비를 교체하면 선택한 장비와 다른 장비의 위치가 서로 바뀝니다.',
            swappingEquipmentCaption: '기존 기록에는 영향을 주지 않지만 경로의 장비 순서는 변경됩니다.',
            selectedEquipment: '선택된 장비',
            swapWith: '교체 대상',
            selectEquipment: '장비 선택',
            swapEquipment: '장비 교체',
          },
        },
      },
      companySettings: {
        settings: {
          adminLicenses: {
            aal: '할당된 관리자 라이선스',
            of: '/',
            edit: '편집',
          },
          essentialMode: {
            disable: '비활성화',
            enable: '활성화',
            essential: 'Essential 모드:',
            enabled: '활성',
            disabled: '비활성',
            moveCompany: '{{company}} 회사를 Essential 모드로 전환',
            affectedCompanies: '영향받는 회사 수',
            affectedAccounts: '영향받는 계정 수',
            archivedLeak: '보관된 누출 기록 수',
            applyingChanges:
              '이 변경을 적용하면 계정이 “Essential” 역할을 갖게 됩니다. 사용자는 대시보드와 모바일 앱에서 최근 {{quota}}개의 누출 기록만 볼 수 있으며 나머지 기록은 보관됩니다.',
            essentialLabel: '하위 회사 Essential 설정 변경',
            turnOffEssential: '{{company}} 회사의 Essential 모드 해제',
            byApplyingChanges:
              '이 변경을 적용하면 모든 계정이 “User” 역할을 갖게 됩니다. 사용자는 모든 기록을 볼 수 있으며 모든 기록이 보관 해제됩니다.',
          },
          hubspotSync: {
            disable: '비활성화',
            enable: '활성화',
            hubspot: 'HubSpot 동기화',
            enabled: '활성',
            disabled: '비활성',
            enableHubspotSync: '{{company}} 회사의 HubSpot 동기화를 활성화',
            disableHubspotSync: '{{company}} 회사의 HubSpot 동기화를 비활성화',
            affectedCompanies: '영향받는 회사 수',
            applyingChanges: '이 변경을 적용하면 HubSpot 동기화가 {{status}}됩니다.',
            hubspotLabel: '하위 회사 HubSpot 동기화 변경',
          },
          convertToSuperCompany: {
            title: '회사 구조 재조정',
            newParentCompany: '새 상위 회사',
            confirmChange: '새 회사 구조 확인',
            confirmChangeMessage: '{{child}} 회사를 {{parent}}의 하위 회사로 전환하시겠습니까?',
            convertSuccess: '회사 구조가 성공적으로 재조정되었습니다',
            convertError: '회사 구조 재조정 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
          },
          deploymentTransfer: {
            title: '회사 이전',
            senderTab: '소스',
            receiverTab: '대상',
            configured: '구성됨',
            checkConfiguration: '구성 확인',
            configuredFrom: '이전 구성은 상위 회사에서 상속됨',
            errorBoundary: '회사 이전을 불러오는 중 오류가 발생했습니다.',
            sender: {
              notConfigured: '구성되지 않음',
              awaitingConnection: '연결 대기 중',
              awaitingS3Config: 'S3 구성 필요',
              title: '소스 구성',
              description: '이 배포를 데이터 이전의 소스로 구성합니다.',
              stepOne: '1단계: 대상 URL 구성',
              stepOneDescription: '대상 배포 URL을 입력하세요.',
              stepTwo: '2단계: API 키 공유',
              stepTwoDescription: 'API 키를 복사하여 공유하세요.',
              stepThree: '3단계: S3 자산 마이그레이션',
              stepThreeDescription: 'S3 자산 마이그레이션을 구성합니다.',
              apiKey: 'API 키',
              copyKey: 'API 키 복사',
              regenerateKey: 'API 키 재생성',
              keyCopied: 'API 키가 복사되었습니다',
              keyRegenerated: 'API 키가 재생성되었습니다',
              connected: '대상에 연결됨',
              connectedTo: '연결된 회사: {{companyId}}',
              notConnectedWarning: '경고: 대상에 연결되지 않았습니다.',
              targetUrl: '대상 URL',
              lambdaFunction: 'Lambda 함수 이름',
              bucketAutoConfig: '버킷은 자동으로 구성됩니다.',
              saveSuccess: '소스 구성이 저장되었습니다',
              saveError: '소스 구성 저장 실패',
              regenerateError: 'API 키 재생성 실패',
              deleteConfig: '구성 삭제',
              deleteConfirmMessage: '소스 구성을 삭제하시겠습니까?',
              deleteSuccess: '소스 구성이 삭제되었습니다',
              deleteError: '소스 구성 삭제 실패',
            },
            receiver: {
              notConfigured: '구성되지 않음',
              title: '대상 구성',
              description: '이 배포를 데이터 이전 대상으로 구성합니다.',
              sourceUrl: '소스 URL',
              apiKey: 'API 키',
              apiKeyPlaceholder: '64자 API 키를 붙여넣으세요',
              invalidApiKey: 'API 키는 정확히 64자여야 합니다',
              connected: '연결됨',
              pending: '대기 중',
              connectedFrom: '연결된 회사: {{companyId}}',
              saveAndConnect: '저장 및 연결',
              connectionSuccess: '연결 성공',
              handshakePending: '구성이 저장되었습니다. 연결 대기 중입니다.',
              saveError: '구성 저장 실패',
              deleteConfig: '구성 삭제',
              deleteConfirmMessage: '대상 구성을 삭제하시겠습니까?',
              deleteSuccess: '대상 구성이 삭제되었습니다',
              deleteError: '대상 구성 삭제 실패',
            },
            operations: {
              title: '전송 작업',
              description: '이 배포에서 대상 배포로 데이터와 자산을 전송합니다.',
              notConnected: '경고: 대상 배포에 연결되지 않았습니다.',
              stepTransferData: '1단계: 데이터 전송',
              stepTransferAssets: '2단계: 자산 전송',
              transferComplete: '전송 완료',
              completed: '완료됨',
              inProgress: '진행 중',
              notStarted: '시작되지 않음',
              pending: '대기 중',
              transferAll: '모든 컬렉션 전송',
              refreshStatus: '상태 새로 고침',
              migrateS3: 'S3 자산 마이그레이션',
              transferStarted: '전송이 시작되었습니다',
              transferError: '전송 시작 실패',
              s3MigrationStarted: 'S3 자산 마이그레이션 시작됨',
              s3MigrationError: 'S3 자산 마이그레이션 실패',
              overallStatus: '전체 상태',
              totalDuration: '총 소요 시간',
              completedAt: '완료 시간',
              initiatedBy: '시작자',
              collection: '컬렉션',
              status: '상태',
              documents: '문서',
              duration: '소요 시간',
              assetType: '자산 유형',
              documentsProcessed: '처리된 문서',
              parentTransferDescription: '상위 회사의 전송이 완료되어야 이 회사를 전송할 수 있습니다.',
            },
          },
          index: '설정',
        },
        index: {
          loadCompanyError: '회사 정보를 불러올 수 없습니다. 나중에 다시 시도해 주세요',
          companySlug: '회사 슬러그',
          notSelected: '선택되지 않음',
          country: '국가',
          accounts: '계정',
          currency: '통화',
          adminLicenses: '관리자 라이선스',
          totalCustomer: '트리에 있는 총 고객 계정',
        },
      },
      device: {
        registerDeviceView: {
          registerDevice: '디바이스 등록',
          toolTip: '등록 카드 또는 상자에서 일련번호를 확인해 주세요.',
          serialNumberIsRequired: '일련번호는 필수 항목입니다',
          oops: '이런!',
          deviceNotFound: '디바이스 일련번호를 찾을 수 없습니다',
          deviceFoundNdAssociatedCompany: '디바이스가 확인되었으며 회사에 연결되어 있습니다.',
          deviceFound: '디바이스가 확인되었습니다.',
          goToLogin: '로그인으로 이동',
          contactSupport: '지원팀에 문의해 주세요',
        },
        deviceErrorCodes: {
          'B13:001': '디바이스 일련번호를 찾을 수 없습니다',
          'B13:002': '디바이스가 이미 활성화되었습니다',
          'B13:003': '관리자 이메일을 보내지 못했습니다',
          'B13:004': '회사를 찾을 수 없습니다',
          'B13:005': '잘못된 회사입니다',
          'B13:006': '잘못된 유형입니다',
        },
        registerAccountView: {
          createAccountSuccess: '계정이 성공적으로 생성되었습니다',
          createAccountError: '계정 생성 중 오류가 발생했습니다. support@prosaris.ca로 문의해 주세요',
          registerAccount: '계정 생성',
          termsMustBeAccepted: '이용약관에 동의해야 합니다.',
          saleType012Success: '디바이스를 사용하기 위해 로그인할 수 있습니다.',
          saleType3Success: '기본 사용자로 추가되었습니다. 회사 관리자에게 알림이 전송되었습니다.',
          saleType4Success: {
            companyPlatformFound: '회사 플랫폼 라이선스를 찾았습니다.',
            dialogOne: '이 디바이스는 새 회사 플랫폼 라이선스와 연결되어 있습니다.',
            dialogTwo: '귀사의 회사가 이미 시스템에 존재할 수 있습니다.',
            dialogThree: '그럴 경우 관리자에게 문의해 주세요.',
          },
          termsAndConditions: {
            dialogOne: 'Prosaris',
            dialogTwo: '서비스 약관',
            dialogThree:
              '에 동의하며, Prosaris 소프트웨어 사용과 관련된 중요한 내용(Prosaris의 책임 제한, 데이터 처리 방식 등)을 충분히 읽고 이해할 시간을 가졌음을 확인합니다.',
          },
          termsOfServiceModal: {
            termsOfService: '서비스 약관',
          },
          acceptTerms: '약관 동의',
          registerAccountErrorCodes: {
            'B02:001': '잘못된 등록 코드입니다',
            'B02:002': '잘못된 사용자 회사입니다',
            'B02:003': '잘못된 사용자 역할입니다',
            'B02:004': '이미 사용 중인 이메일입니다',
            'B02:005': '이미 사용 중인 이메일입니다',
            'B02:006': '이 계정의 비밀번호를 재설정할 수 없습니다',
            'B02:007': '잘못된 사용자 회사입니다',
            'B02:008': '프로필 사진이 없습니다',
            'B02:009': '계정 재설정이 필요합니다. 프로세스를 시작했습니다',
            'B02:010': '계정이 비활성화되었습니다',
            'B02:011': '프로필 사진 형식이 잘못되었습니다',
            'B02:012': '디바이스가 이미 회사에 등록되어 있습니다',
            'B02:013': '일련번호가 정의되지 않았습니다',
            'B02:014': '잘못된 유형입니다',
            'B02:015': '비밀번호 재설정 링크가 만료되었습니다',
            'B02:016': '이 회사의 계정을 생성할 수 없습니다',
            'B02:017': '잘못된 역할입니다',
            'B02:018': '잘못된 역할입니다',
            'B02:019': '잘못된 사용자 회사입니다',
            'B02:020': '잘못된 사용자 역할입니다',
            'B02:021': '사용자가 이 회사에 속하지 않습니다',
          },
          whichProduct: '어떤 제품을 사용하고 계신가요?',
        },
        devicesView: {
          serialNumbersIsReq: '일련번호가 필요합니다',
          failedToCopy: '실패한 일련번호가 클립보드에 복사되었습니다',
          invalidFormat: '하나 이상의 디바이스 형식이 잘못되었습니다. 확인 후 다시 시도해 주세요.',
          devices: '디바이스 등록',
          deviceSerialNumber: '디바이스 일련번호',
          note: '각 일련번호를 새 줄에 입력하거나 쉼표로 구분해 입력하세요.',
          title: '등록 카드나 상자에서 일련번호를 확인하세요.',
          register: '등록',
          deviceRegistrationStatus: '디바이스 등록 상태',
          success: '성공',
          noDeviceFound: '디바이스를 찾을 수 없습니다.',
          failed: '실패',
          copyFailed: '실패한 일련번호를 클립보드에 복사',
        },
      },
      errors: {
        notFoundView: {
          title: '찾고 있는 페이지가 없습니다',
          description: '잘못된 경로로 이동했거나 오류로 접근하신 것 같습니다. 내비게이션을 사용해 다시 이동해 보세요.',
        },
        accountNotFound: {
          title: '계정을 찾을 수 없습니다',
          description:
            '다시 시도해 주세요! 문제가 지속되면 계정이 현재 비활성 상태이거나 관리자가 아직 초기화하지 않았을 수 있습니다. 관리자에게 문의해 주세요.',
          logout: '로그아웃',
        },
      },
      integration: {
        index: {
          loggingInError: 'Prosaris에 로그인하는 중 오류가 발생했습니다.',
        },
      },
      leakRecordDetails: {
        assignedActions: {
          actionImages: '사용 가능한 이미지가 없습니다',
          activeActionRecord: {
            updateAssignmentSuccess: '할당된 조치가 업데이트되었습니다.',
            updateAssignmentError: '조치를 업데이트하는 중 오류가 발생했습니다.',
            deleteImageSuccess: '할당된 이미지가 삭제되었습니다.',
            deleteImageError: '할당된 조치 이미지를 삭제하는 중 오류가 발생했습니다.',
            confirmMarkAction: '이 할당을 완료하면 기록이 완료로 표시되고 관련된 모든 조치가 비활성화됩니다. 계속 진행하시겠습니까?',
            confirmDeleteImage: '정말 이 이미지를 삭제하시겠습니까?',
          },
          index: '기록에 대한 할당된 조치를 불러오는 중 오류가 발생했습니다.',
        },
        audio: {
          noAudioAvailable: '오디오 데이터가 없습니다',
          errorDownloadingAudio: '오디오 다운로드 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
          playPause: '재생 / 일시정지',
          generateRegion: '구간 생성',
          removeLastRegion: '마지막 구간 제거',
          generateMarker: '마커 생성',
          removeLastMarker: '마지막 마커 제거',
          toggleTimeline: '타임라인 표시/숨기기',
          download: '다운로드',
        },
        audit: {
          updateAuditSuccess: '감사가 성공적으로 업데이트되었습니다',
          updateAuditError: '코멘트를 저장하는 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
          createAuditSuccess: '감사가 성공적으로 생성되었습니다',
          createAuditError: '감사를 생성하는 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
          deleteAuditSuccess: '감사가 성공적으로 삭제되었습니다',
          deleteAuditError: '감사를 삭제하지 못했습니다. 나중에 다시 시도해 주세요.',
          noComment: '코멘트 없음',
          reviewComments: '검토 코멘트',
          reviewedBy: '검토자:',
          auditDate: '감사 날짜:',
          deleteAudit: '감사 삭제',
          reviewedNoComments: '코멘트 없이 검토 완료',
          auditComments: '감사 코멘트',
          saveComment: '코멘트 저장',
          discardChanges: '변경 취소',
        },
        changeHistory: {
          created: '생성됨',
          updated: '업데이트됨',
          deleted: '삭제됨',
          synced: '동기화됨',
          transferred: '전송됨',
          leak: '기록',
          images: '이미지',
          audit: '감사',
          audio: '오디오',
          history: '히스토리',
          noHistory: '히스토리가 없습니다',
          bulk: '일괄 작업',
          details: '세부 정보',
          unset: '해제',
        },
        fft: {
          fft: 'FFT',
          fftAvg: 'FFT 평균',
          notApplicable: '해당 없음',
          chartLayers: '차트 레이어',
          avg: '평균',
          all: '전체',
          playing: '재생 중...',
          showTimeSeries: '시계열 표시',
          xAxis: '주파수 (Hz)',
          yAxis: '크기',
          frame: '프레임',
          speed: '속도',
          play: '재생',
          pause: '일시 정지',
          resetZoom: '확대 재설정',
        },
        form: {
          updateLeakSuccess: '성공적으로 업데이트되었습니다.',
          updateLeakError: '기록을 업데이트하는 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
          alertTitle: {
            partOne: '기록이',
            partTwo: '읽기 전용',
            partThree: '모드입니다.',
          },
          alertDialog: {
            dialogOne: '다음 속성은 수정할 수 있습니다:',
            dialogTwo: '조치 상태',
          },
          GPSLocation: 'GPS 위치',
          completedOn: '완료일:',
          lastSaved: '마지막 저장:',
          updateConfirmMessage: '이 기록을 완료하면 관련된 모든 조치가 비활성화됩니다. 계속 진행하시겠습니까?',
          updateConfirmTitle: '기록 완료 확인',
          smartTagHelp: 'PROSARIS 스마트 태그 자세히 알아보기',
        },
        images: {
          removeSuccess: '이미지가 성공적으로 삭제되었습니다.',
          removeError: '기록 이미지를 삭제할 수 없습니다. 나중에 다시 시도해 주세요',
          text: '정말 이 이미지를 삭제하시겠습니까?',
          addImages: '이미지 추가',
          additionalImages: '추가 이미지',
          noAdditionalImages: '추가 이미지 없음',
          uploadSuccess: '이미지가 성공적으로 업로드되었습니다.',
          uploadError: '이미지를 업로드할 수 없습니다. 나중에 다시 시도해 주세요.',
          maxImagesReached: '레코드당 최대 10개의 추가 이미지입니다.',
          tooManyFiles: '{{count}}개의 이미지를 추가할 수 없습니다. {{remaining}}개만 더 추가할 수 있습니다.',
        },
        index: {
          title: '기록',
          loadingError: '기록을 불러오는 중 오류가 발생했습니다. 다시 시도해 주세요.',
          unsavedMessage: "'확인'을 누르면 저장되지 않은 변경 사항이 모두 삭제됩니다",
          notAnAuditor: '감사자가 아닙니다',
          anEssential: 'Essential 요금제를 사용 중입니다',
          showHistory: '히스토리 보기',
        },
        massFlow: {
          recalculating: '누출 파라미터 설정에 따라 유량/손실을 다시 계산 중...',
          warning: '입력 값이 변경되었거나 계산이 오래되었습니다. `재계산`을 눌러 유량과 손실 값을 새로 고치세요.',
          calculatingError: '질량 유량 계산 중 오류가 발생했습니다. 다시 시도해 주세요.',
          noValue: '값 없음',
          calculatingSuccess: '유량/손실이 재계산되었습니다',
          recalculate: '재계산',
          calculatorVersion: '계산 버전:',
          noteDialog: {
            dialogOne: '누출 파라미터 설정을 변경하면 유량/손실 계산이 업데이트됩니다. 자세한 내용은',
            dialogTwo: '계산 인사이트',
            dialogThree: '페이지를 확인하세요',
          },
        },
        unsavedWarningDialog: {
          recordChanged: '기록이 변경되었습니다',
          close: '닫기',
          unsavedChanges: '이 기록에는 저장되지 않은 변경 사항이 있습니다. 저장하거나 변경 사항을 삭제해 주세요.',
          discardChanges: '변경 사항 삭제',
        },
      },
      leakRecordCreate: {
        form: {
          deviceIDIsRequired: '디바이스 ID는 필수 항목입니다',
          dbPeakIsRequired: '피크 dB 측정 값은 필수 항목입니다',
          dbMin: '피크 dB 측정 값은 0 이상이어야 합니다',
          dbMax: '피크 dB 측정 값은 95 이하여야 합니다',
          dbError: '피크 dB 측정 값은 숫자여야 합니다',
          imageUploadError: '이미지 업로드 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
          createLeakSuccess: '기록이 성공적으로 추가되었습니다',
          createLeakError: '기록을 생성하지 못했습니다. 나중에 다시 시도해 주세요.',
          basicInfo: '기본 정보',
          flowInput: '유량 입력',
          mainGas: '주요 가스/관심 구성 요소',
          selectComponent: '구성 요소 선택',
          selectLeakType: '누출 유형 선택',
          mightBeSomethingHere: '추후 업데이트 예정',
          energyLoss: '에너지 손실',
          selectCompressorType: '컴프레서 유형 선택',
          noRoutes: '경로를 찾을 수 없습니다',
          noEquipment: '장비를 찾을 수 없습니다',
          noRouteEquipment: '경로 장비를 찾을 수 없습니다',
          routeEquipmentInfo: '경로 장비 세부 정보',
          noLocations: '위치를 찾을 수 없습니다',
          energyCost: '에너지 비용',
          audioRecording: '오디오 녹음',
          leakSourceEquipment: '원인 장비',
          selectComponentType: '구성 요소 유형 선택',
          selectService: '서비스 선택',
          locationAndUser: '위치 및 사용자',
          leakEventStatus: '이벤트 상태',
          low: '낮음',
          medium: '중간',
          high: '높음',
          open: '열림',
          complete: '완료',
          reset: '초기화',
        },
        formElectrical: {
          systemVoltages: '시스템 전압',
          source: '소스',
        },
        images: {
          leakSourceImageCapture: '원본 이미지 캡처',
          add: '추가',
        },
        index: {
          title: '기록 생성',
        },
      },
      leakRecordsList: {
        filters: {
          from: '시작일',
          to: '종료일',
          qualifier: '조건',
          savedFilters: '저장된 필터',
          filter: '필터',
          selectFilter: '필터 선택...',
          filterName: '필터 이름',
          filterNameRequired: '필터 이름은 필수 항목입니다',
          filtersNotAvailable: '필터를 사용할 수 없습니다',
          saveFilterTitle: '필터 저장',
          deleteSavedFilterTitle: '필터 삭제 확인',
          deleteSavedFilterMessage: '"{{savedFilterName}}" 필터를 삭제하시겠습니까?',
          createFilterSuccess: "필터 '{{filter}}'가 생성되었습니다. 기록 필터 → 저장된 필터에서 접근할 수 있습니다",
          createFilterError: '필터를 생성하지 못했습니다. 나중에 다시 시도해 주세요.',
          deleteFilterSuccess: '필터가 삭제되었습니다',
          deleteFilterError: '필터를 삭제하지 못했습니다. 나중에 다시 시도해 주세요.',
          emptyFilter: '값 없음',
        },
        modalAssignUsers: {
          assignLeakRecord: '기록 할당',
          selectAUserToAssign: '선택된 기록에 할당할 사용자를 선택하세요',
          filterByName: '이름으로 필터',
          filterByEmployeeName: '직원 이름으로 필터',
          unexpectedError: '예상치 못한 오류가 발생했습니다',
          noUserFound: '사용자를 찾을 수 없습니다',
          assigningActionForSelectedRecords: '선택된 기록에 조치를 할당하는 중...',
        },
        modalTransferRecords: {
          transferRecords: '기록 전송',
          selectCompany: '회사 선택',
          selectCompanyPlaceholder: '회사를 선택하세요',
          selectUser: '사용자 선택',
          selectUserPlaceholder: '사용자를 선택하세요',
          noUserFound: '사용자를 찾을 수 없습니다',
          unexpectedError: '예상치 못한 오류가 발생했습니다',
        },
        modalBulkEdit: {
          titleSingleRecord: '기록 {{selectedRecordsCount}}건 일괄 편집',
          title: '기록 {{selectedRecordsCount}}건 일괄 편집',
          selectAField: '필드 선택',
          verifyAction: '다른 사용자의 기록을 업데이트하려고 합니다. 선택된 기록 수를 입력해 확인해 주세요.',
          matchCountError: '선택된 기록 수({{selectedRecordsCount}})와 일치해야 합니다',
          moreThanOneType: '선택된 기록 유형이 여러 개입니다. 일부 필드는 일괄 편집을 사용할 수 없습니다.',
          companyFilterRequired: '경로 필드를 편집하려면 먼저 회사 필터를 적용하세요. 경로는 회사/시설별로 다릅니다.',
          selectCompanyForRoute:
            '경로는 회사/시설별로 다릅니다. 회사를 선택하면 필터가 적용되고 이 대화 상자가 닫힙니다. 기록을 다시 선택하고 일괄 편집을 다시 열어야 합니다.',
        },
        tableHead: {
          youAreSelecting: '선택 중:',
          visibleRecords: '표시된 기록',
          andAllUnloadedRecords: '및 로드되지 않은 모든 기록.',
          allRecordsWillBeLoaded: '모든 기록을 로드하고 선택합니다.',
          thisCanTakeAWhile: '기록이 많으면 시간이 걸릴 수 있습니다.',
          allRecords: '보이지 않는 기록을 포함한 전체 기록',
          selectAllRecords: '모든 기록 선택',
        },
        tableBody: {
          noRecordsToDisplay: '표시할 기록이 없습니다.',
        },
        toolBar: {
          assign: '할당',
          assignToSelf: '내게 할당',
          assignToSelfDialogTitle: '기록 할당 확인',
          assignToSelfDialogMessage: '{{len}}개의 기록을 자신에게 할당하시겠습니까?',
          onEssentialPlan: '현재 Essential 요금제를 사용 중입니다. support@prosaris.ca로 문의해 주세요',
          bulkEdit: '일괄 편집',
          transfer: '전송',
          bulkEditSuccess: '기록 {{len}}건이 성공적으로 업데이트되었습니다',
          bulkEditSuccessPlural: '기록 {{len}}건이 성공적으로 업데이트되었습니다',
          bulkEditError: '기록을 업데이트하지 못했습니다. 나중에 다시 시도해 주세요',
          export: '내보내기',
          exportPDF: 'PDF 내보내기',
          needAdminLicense: '이 기능에 접근하려면 관리자 라이선스가 필요합니다. support@prosaris.ca로 문의해 주세요',
          create: '생성',
          deleteRecordMessage: '선택된 기록을 삭제하시겠습니까?',
          deleteRecordMessagePlural: '선택된 기록을 삭제하시겠습니까?',
          permissionDenied: '권한이 없습니다!',
          notAllowedToDelete: '삭제 권한이 없는 다른 사용자의 기록이 포함되어 있습니다. 선택에서 제거해 주세요.',
          generatingPDF: 'PDF 생성 중...',
          csvExportProcessing: '파일을 처리 중입니다. 완료되면 자동으로 다운로드됩니다.',
          cannotGeneratePDF:
            '현재 {{numberSelected}}개의 기록을 하나의 PDF로 내보낼 수 없습니다. 최대 {{limitRecords}}개까지 선택해 주세요.',
          cannotExportMessage: '{{numberSelected}}개의 기록을 내보낼 수 없습니다',
          bulkEditLimitExceeded: '{{maxAllowed}}개를 초과해서는 편집할 수 없습니다. support@prosaris.ca로 문의해 주세요',
          selectAtLeastOneRecord: '최소 한 개의 기록을 선택해 주세요',
        },
        index: {
          cannotLoadLeakRecord: '죄송합니다. 현재 기록을 불러올 수 없습니다',
          successfullyAssignedAllRecords: '모든 기록을 성공적으로 할당했습니다',
          actionRecordAssigned: '조치 기록이 할당되었습니다!',
          actionRecordAssignedPlural: '조치 기록이 할당되었습니다!',
          errorWhileAssigningLeak: '기록을 할당하는 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
          successfullyDeletedAllRecords: '모든 기록이 성공적으로 삭제되었습니다',
          successfullyDeletedRecord: '누출 기록 {{length}}건이 성공적으로 삭제되었습니다',
          successfullyDeletedRecordPlural: '누출 기록 {{length}}건이 성공적으로 삭제되었습니다',
          errorOnRecordsDelete: '기록 삭제 중 오류가 발생했습니다. 나중에 다시 시도해 주세요',
          leakPreview: '미리보기',
          leakRecord: '기록: ',
          failedAssignments: '할당 실패 ({{failed}})',
          failedAssignmentCodes: {
            'B04:012': '기록이 닫혀 있습니다',
          },
          displayedRows: '{{from}}-{{to}} / {{count}}',
          rowsPerPage: '페이지당 행 수:',
          previousPage: '이전 페이지',
          nextPage: '다음 페이지',
          csvExportSuccess: '내보내기가 완료되었습니다',
          csvExportError: '내보내기 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
        },
      },
      tagList: {
        resetTag: '태그 초기화',
        dataExport: {
          smartLeakTagsFormat: '스마트 태그 형식',
          smartLeakTagsDescription: '스마트 태그 페이지에 표시되는 기본 필드를 포함합니다',
          standardLeakRecordFormat: '표준 기록 형식',
          standardLeakRecordDescription: '누출 기록과 관련된 모든 필드를 포함합니다',
        },
        filters: { smartLeakTagFilters: '스마트 태그 필터' },
        index: {
          cannotLoadTags: '죄송합니다. 현재 스마트 태그를 불러올 수 없습니다',
          updateLeakSuccess: '스마트 태그가 성공적으로 초기화되었습니다.',
          updateLeakError: '스마트 태그를 초기화하는 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
          bulkEditSuccess: '스마트 태그 {{len}}개가 성공적으로 초기화되었습니다',
          bulkEditSuccessPlural: '스마트 태그 {{len}}개가 성공적으로 초기화되었습니다',
          bulkEditError: '스마트 태그 초기화 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
          tagsFileName: '스마트 태그',
          leakFileName: '기록',
        },
        tableBody: {
          title: '태그 초기화를 확인해 주세요',
          alertDialog: {
            dialogOne: '다음 작업을 수행하려고 합니다:',
            dialogTwo: '태그 초기화',
            dialogThree: '대상 기록:',
            dialogFour: '조치 상태: OPEN',
            dialogFive: '계속 진행하시겠습니까?',
          },
        },
        toolBar: {
          resetTags: '태그 초기화',
          title: '태그 일괄 초기화 확인',
          alertDialog: {
            dialogOne: '선택 항목에 포함된 기록 수:',
            dialogTwo: '개, 조치 상태:',
            dialogTwoPlural: '개, 조치 상태:',
            dialogThree: 'OPEN',
            dialogFour: '계속 진행하시겠습니까?',
          },
          exportFormatCSV: 'CSV 내보내기 형식 선택',
          exportFormatPDF: 'PDF 내보내기 형식 선택',
        },
      },
      myDashboard: {
        assignedActions: {
          index: {
            errorMessage: '할당된 조치를 불러오는 중 오류가 발생했습니다. 다시 시도해 주세요.',
          },
        },
        kpi: {
          title: '핵심 성과 지표',
          filters: '필터',
          myData: '내 데이터',
          companyData: '회사 데이터',
          financialTitle: '비용 절감',
          leaksTitle: '이벤트 통계',
          energyTitle: '에너지 절감',
          totalIdentified: '식별된 총계',
          repaired: '수리됨',
          unrepaired: '미수리',
          ofTotal: '전체 중',
          myStanding: '내 순위',
          gaugeTooltipLeaks: '선택한 기간에 누출을 기록한 다른 사용자와 누출 수를 비교합니다. 막대는 최저에서 최고 수까지의 범위입니다.',
          gaugeTooltipEnergy:
            '선택한 기간에 누출을 기록한 다른 사용자와 에너지 절감을 비교합니다. 막대는 최저에서 최고 kWh 값까지의 범위입니다.',
          gaugeTooltipCost: '선택한 기간에 누출을 기록한 다른 사용자와 비용을 비교합니다. 결과는 통화별로 그룹화됩니다.',
          tooltipCostTotal: '귀하가 파악한 잠재적 비용 절감의 총 가치입니다. 순위에는 비용 절감을 파악한 귀사의 모든 사용자가 포함됩니다.',
          tooltipCostRepaired: '귀하가 파악한 비용 절감 중 해결된 부분입니다.',
          tooltipCostUnrepaired: '귀하가 파악한 비용 절감 중 미해결 부분입니다.',
          tooltipLeaksTotal:
            '귀하가 생성하여 플랫폼에 업로드한 누출 기록의 총 수입니다. 순위에는 최소 하나의 기록을 업로드한 귀사의 모든 사용자가 포함됩니다.',
          tooltipLeaksRepaired: '귀하의 기록 중 해결된 부분입니다.',
          tooltipLeaksUnrepaired: '귀하의 기록 중 미해결 부분입니다.',
          tooltipEnergyTotal:
            '귀하가 파악한 잠재적 에너지 절약의 총 가치입니다. 순위에는 에너지 절약을 파악한 귀사의 모든 사용자가 포함됩니다.',
          tooltipEnergyRepaired: '귀하가 파악한 에너지 절약 중 해결된 부분입니다.',
          tooltipEnergyUnrepaired: '귀하가 파악한 에너지 절약 중 미해결 부분입니다.',
          gaugeLowest: '최저',
          gaugeHighest: '최고',
          noData: '선택한 필터에 대한 데이터가 없습니다.',
          apply: '적용',
          cancel: '취소',
          changeDates: '날짜 변경',
          loading: '로딩 중...',
          selectDateRange: '날짜 범위 선택',
          startDate: '시작 날짜',
          endDate: '종료 날짜',
          selectDateRangeDescription: '날짜 범위를 선택한 후 적용을 클릭하여 KPI를 확인하세요.',
          datePresets: {
            label: '날짜 프리셋',
            today: '오늘',
            yesterday: '어제',
            last7Days: '지난 7일',
            last30Days: '지난 30일',
            thisWeek: '이번 주',
            lastWeek: '지난 주',
            thisMonth: '이번 달',
            lastMonth: '지난 달',
            thisYear: '올해',
            lastYear: '작년',
            allTime: '전체 기간',
          },
          calendar: {
            weekDays: {
              mon: '월',
              tue: '화',
              wed: '수',
              thu: '목',
              fri: '금',
              sat: '토',
              sun: '일',
            },
            months: {
              january: '1월',
              february: '2월',
              march: '3월',
              april: '4월',
              may: '5월',
              june: '6월',
              july: '7월',
              august: '8월',
              september: '9월',
              october: '10월',
              november: '11월',
              december: '12월',
            },
          },
        },
        charts: {
          charts: {
            errorMessages: {
              errorMessageOne: '누출 기록을 불러오는 중 오류가 발생했습니다. 다시 시도해 주세요.',
            },
          },
        },
        index: {
          assignedActions: '내게 할당된 조치',
        },
      },
      export: {
        imageUrl: '레코드 이미지 URL {{number}}',
        additionalImageUrl: '추가 누출 이미지 URL {{number}}',
        audioFileUrlOne: '오디오 파일 URL',
        smartTag: '스마트 태그',
        workRef: '작업 참조',
        per: '당 ',
      },
      downloadApk: {
        pageTitle: 'PROSARIS - 앱 다운로드',
        title: 'PROSARIS 앱 다운로드',
        mobileInstructions:
          '태블릿 또는 모바일 기기에서 이 페이지를 보고 있는 경우, 아래의 "다운로드" 버튼을 눌러 PROSARIS 앱을 기기에 다운로드하세요.',
        desktopInstructions:
          '컴퓨터에서 이 페이지를 보고 있는 경우, 태블릿이나 모바일 기기로 QR 코드를 스캔하여 그곳에서 앱을 다운로드하세요.',
        downloadButton: '다운로드',
        qrCodeLabel: 'PROSARIS 앱 다운로드',
        additionalInstructions: {
          title: '추가 다운로드 안내',
          description:
            '웹사이트에서 APK(Android 패키지 키트)를 다운로드 중이며, Google Play에서 다운로드할 때보다 추가적인 보안 절차가 필요할 수 있습니다.',
          step1: '"파일이 해로울 수 있습니다"라는 경고가 표시될 수 있습니다. "그래도 다운로드"를 선택하세요.',
          step2:
            '기기에서 "이 소스에서 알 수 없는 앱 설치가 허용되지 않습니다"라는 알림이 표시될 수 있습니다. 기기 설정을 열도록 안내됩니다.',
          step3: '설정 페이지에서 스위치를 켜서 알 수 없는 앱 다운로드를 허용하세요.',
          step4: '마지막 보안 단계로 "앱 검사"를 요청받을 수 있습니다. 검사 후 앱 다운로드가 진행됩니다.',
        },
      },
    },
    languages: {
      English: '영어',
      Chinese: '중국어',
      Spanish: '스페인어',
      French: '프랑스어',
      German: '독일어',
      Norwegian: '노르웨이어',
      Italian: '이탈리아어',
      Turkish: '터키어',
      Japanese: '일본어',
      Portuguese: '포르투갈어',
      Korean: '한국어',
    },
  },
};
